import React, { PureComponent } from "react";
import {
  Form,
  Col,
  Button,
  Image,
  OverlayTrigger,
  Tooltip,
  InputGroup
} from "react-bootstrap";
import { Prompt } from "react-router-dom";
import IndiaMap from "../../assets/india-map.png";
import IndiaEmblem from "../../assets/india-emblem.png";
import IconPin from "../../assets/icon-pin.png";
import InfoIcon from "../../assets/small-info-icon.svg";
import Level1Flag from "../../assets/level1_flag.svg";
import Level2Flag from "../../assets/level2_flag.svg";
import Level3Flag from "../../assets/level3_flag.svg";
import Level4Flag from "../../assets/level4_flag.svg";
import Level5Flag from "../../assets/level5_flag.svg";
import Level0Flag from "../../assets/flag-level-zero.svg";
import DropdownArrow from "../../assets/down-caret.svg";
import { debounce, get, remove } from "lodash";
import {
  uploadFileAction,
  removeFileAction,
  getIssuesCategoryListAction,
  getIssuesSubCategoryListAction,
  getForumListAction,
  getBucketListAction,
  getMilestoneTableDataAction,
  getMilestonesDataAction,
  getDistrictAndDepartmentIssues,
  proposalDetailValidation
} from "../../actions/common.action";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  FormDataForImage,
  isValidArray,
  transformProjectCategoryId,
  GROUP_KEYS,
  getLocalstorage,
  handleLanguage,
  handlePaste
} from "../../helper";
import {
  getAutoCompleteListAction,
  getGroupByCategoryAndParentId,
  getGroupCategoryIdAction,
  getProjectPageInfoAction,
  getAutoCompleteListUserAction
} from "../../actions/createProject.action";
import { FILE_FORMATS, STATUS, ERROR_MSG, VIDEO_FORMATS } from "../../constant";
import { toast } from "react-toastify";
import { InnerLoader } from "../../component/Loader";
import { AutoSuggestSelect } from "../../component/AutoSuggestSelect";
import DisplayByPermission from "../../component/DisplayByPermission";
import SelectStateDropDown from "../dropdown";
import { UploadAttachmentsWithTitleComponent } from "../reusableComponent";
import { DatePicker } from "../../component";
import { VideoPlayerModal } from "../reusableComponent/modal/videoPlayerModal";
import CircleWithExclamation from "../../assets/circle-with-exclamation.svg";
import { successToastStyle, errorToastStyle } from "../../customToast";
import TooltipComponent from "../../component/TooltipComponent";
import {
  modifyDataOfAddIssue,
  validateDuplicatedIssue,
  PromisesHelper
} from "../../helper";
import { isIssueDuplicatedAction } from "../../actions/issues.action";
import ReactQuill from "react-quill";
import Delta from "quill-delta";
import "react-quill/dist/quill.snow.css";
import CustomDropdown from "../reusableComponent/Dropdown/CustomDropdown";

export const mandatoryFieldsOfAddIssue = [
  "groupCategory",
  "issueCategoryId",
  "issueSubCategoryId",
  "issueDescription",
  "recipientGroupId",
  "responsibleAuthority",
  "title",
  "selectedStateId",
  "selectedMinistryId",
  "stateDistrictAndDepartment"
  // "proposalNoParivesh"
];
let oldStateId;

class AddIssueForm extends PureComponent {
  state = {
    ministryGroupList: [],
    CENTRAL: [],
    STATE: [],
    stateGroupList: [],
    groupList: [{}],
    issueCOList: [{}],
    issueCOListError: [{}],
    subCategoryList: [],
    forumList: [],
    ministryList: [],
    districtList: [],
    secondaryDistrictList: [],
    secondaryDepartmentList: [],
    dataUnsaved: false,
    isIssueSaved: false,
    tableList: [],
    milestoneList: [],
    milestoneTables: [],
    milestoneLists: [],
    canUploadVideo: true,
    showVideoPlayer: false,
    videoUrl: null,
    videoTitle: null,
    languageError: null,
    onPasteError: false,
    key: "",
    pastedText: "",
    indexOfInputField: 0,
    initialRequiredFields: [
      "groupCategory",
      "issueCategoryId",
      "issueSubCategoryId",
      "issueDescription",
      "recipientGroupId",
      "title",
      "selectedStateId",
      "selectedMinistryId",
      "issueSubCategoryId",
      "responsibleAuthority",
      "stateDistrictAndDepartment"
    ],
    Escalationarr: [
      { id: 6, name: "Level 0: Ministry Review", flag: Level0Flag },
      { id: 1, name: "Level 01: PMG", flag: Level1Flag },
      { id: 2, name: "Level 02: Secretary, DPIIT", flag: Level2Flag },
      { id: 3, name: "Level 03: Cabinet Secretariat", flag: Level3Flag },
      { id: 4, name: "Level 04: Monitoring Group, PMO", flag: Level4Flag },
      { id: 5, name: "Level 05: Pragati, PM", flag: Level5Flag }
    ],
    escalationdropdowndisplay: false,
    selectedValue: "- Select Escalation Level -",
    reasonboxDisplay: false,
    escalationReason: "",
    escalationLevelName: "",
    escalationErrormessage: false,
    escalationLevel: "",
    reasonForEscalation: "",
    bordercolorBox: false,
    addSecondary: false,
    deleteSecondary: false,
    addSecondaryForState: false,
    deleteSecondaryForState: false,
    addSecondaryState: false,
    deleteSecondaryState: false,
    proposalValidated: false,
    proposalErrorMessage: "",
    proponentErrormsg: false,
    touchedFields: {},
    formSubmitted: false,
    originalProposalNo: "",
    resetForm: false
  };
  handleDisplayDropdown = () => {
    this.setState({ escalationdropdowndisplay: false });
    const level = this.state.selectedValue;
    const { issueData } = this.props;
    switch (level) {
      case "Level 01: PMG":
      case "Level 02: Secretary, DPIIT":
      case "Level 03: Cabinet Secretariat":
      case "Level 04: Monitoring Group, PM":
      case "Level 05: Pragati, PM":
      case "Level 0: Ministry Review":
        if (issueData.data.escalationLevelName == level) {
          this.setState({
            //reasonboxDisplay: false,

            escalationReason: issueData.data.reasonForEscalation,
            escalationErrormessage: false
          });
        } else {
          this.setState({ reasonboxDisplay: true });
        }
    }
  };

  handleReset = flag => {
    this.setState({ resetForm: flag });
  };

  handleDisplay = () => {
    this.setState({
      escalationdropdowndisplay: true
      //reasonboxDisplay: false,
      //selectedValue: "- Select Escalation Level -"
    });
  };
  getMarginLeft = selectedValue => {
    const level = selectedValue;
    switch (level) {
      case "Level 01: PMG":
        return "14.6em";
      case "Level 02: Secretary, DPIIT":
        return "9.3em";
      case "Level 03: Cabinet Secretariat":
        return "7.8em";
      case "Level 04: Monitoring Group, PMO":
        return "5.8em";
      case "Level 05: Pragati, PM":
        return "11.3em";
      default:
        return "9.4em";
    }
  };
  // call apis
  componentDidMount() {
    if (this.reactQuillRef) {
      const quill = this.reactQuillRef.getEditor();

      // Block pasted <img>
      quill.clipboard.addMatcher("img", () => new Delta());

      // Block links, keep only text
      quill.clipboard.addMatcher("a", node => {
        //return new Delta().insert(node.innerText);
        return new Delta().insert(node.textContent || "");
      });
    }
    const user = getLocalstorage("user");
    const isStatePMG = user.groupCategory === "STATE_PMG";
    const isStateDepartment = user.groupCategory === "STATE_DEPARTMENT";
    const {
      params: {
        isEdit,
        issueDetails,
        issuesProps = {},
        updateParentState,
        workflowType,
        createdBy,
        updateParentStateError,
        isProjectAwardedByState,
        issueData
      },
      backButtonPress,
      issueCOListData,
      ministryList,
      STATE,
      districtList,
      subCategoryList,
      milestoneTables,
      milestoneLists,
      CENTRAL,
      DISTRICT,
      STATE_DEPARTMENT,
      CENTRAL_DEPARTMENT,
      OTHER,
      INDUSTRIAL
    } = this.props;
    if (backButtonPress) {
      this.setState({
        issueCOList: issueCOListData,
        ministryList: ministryList,
        STATE: STATE,
        districtList: districtList,
        subCategoryList: subCategoryList,
        milestoneLists: milestoneLists,
        milestoneTables: milestoneTables,
        CENTRAL: CENTRAL,
        DISTRICT: DISTRICT,
        STATE_DEPARTMENT: STATE_DEPARTMENT,
        CENTRAL_DEPARTMENT: CENTRAL_DEPARTMENT,
        OTHER: OTHER,
        INDUSTRIAL: INDUSTRIAL
      });
      // this.getGroupCategoryId([issueCOListData[0].groupCategory]);
    } else {
      this.getIssueByCategory();
      this.getBucketsData();
      if (isValidArray(issueDetails)) {
        if (isValidArray(issueDetails)) {
          const firstIssueDetail = issueDetails[0];
          const issueListFormat = [];
          const errorListFormat = [];
          issueDetails.forEach((issue, index) => {
            if (true) {
              const defaultSelected =
                get(issue, "previousCreatedBy") || get(issue, "userID");
              const defaultSelectedForState =
                get(issue, "stateUserAutocompleteDTO") || get(issue, "userID");
              issueListFormat.push({
                ...issue,
                defaultSelected:
                  isStatePMG || isStateDepartment
                    ? defaultSelectedForState &&
                      `${defaultSelectedForState.name} (${
                        defaultSelectedForState.organization
                      })`
                    : defaultSelected &&
                      `${defaultSelected.name} (${defaultSelected.userID})`,
                userID: get(issue, "previousCreatedBy") || get(issue, "userID"),
                title: get(issue, "title", ""),
                files: get(issue, "files") || get(issue, "fileManagerList", [])
              });
              errorListFormat.push({
                title: { error: false },
                issueDescription: { error: false },
                issueSubCategoryId: { error: false },
                issueCategoryId: { error: false }
              });
              this.getIssueSubCategory(get(issue, "issueCategoryId"), index);
              this.getIssueForum(get(issue, "issueCategoryId"), index);
              get(issue, "groupCategory") &&
                this._getGroupByCategoryAndParentId([
                  get(issue, "groupCategory")
                ]);
              // this._getGroupByCategoryAndParentId(["STATE_DEPARTMENT"]);
              // if (get(issue, "secondaryRecipientGroupId")) {
              const passedParam =
                get(issue, "recipientGroupCategory") == "DISTRICT"
                  ? "STATE_DEPARTMENT"
                  : "DISTRICT";
              this._getGroupByCategoryAndParentId([passedParam]);
              // }
            }
          });

          this.setState(
            {
              issueCOList: issueListFormat,
              ...issuesProps,
              projectId:
                !Array.isArray(issueDetails) && get(issueDetails, "projectId"),
              issueCOListError: errorListFormat
            },
            () => {
              this.getGroupCategoryId([GROUP_KEYS.CENTRAL]);
              if (
                get(firstIssueDetail, "projectIssueDTO.sponsoredByCategory") ===
                GROUP_KEYS.STATE
              ) {
                this.getGroupCategoryId(
                  [GROUP_KEYS.STATE],
                  get(firstIssueDetail, "projectIssueDTO.sponsoredByid")
                );
              } else {
                this.getGroupCategoryId([GROUP_KEYS.STATE]);
              }
              if (
                isProjectAwardedByState &&
                this.state.issueCOList &&
                isValidArray(this.state.issueCOList) &&
                this.state.issueCOList[0] &&
                this.state.issueCOList[0].title !== ""
              ) {
                this.state.issueCOList.forEach((item, index) => {
                  this.onSelectState(index);
                  this.onSelectSecondary(index);
                });
              } else {
                if (get(firstIssueDetail, "recipientGroupId")) {
                  if (this.state.issueCOList && this.state.issueCOList[0]) {
                    if (
                      this.state.issueCOList[0].groupCategory ===
                      GROUP_KEYS.STATE
                    ) {
                      this.onSelectState(0, "state");
                      this.onSelectSecondary(0, "central");
                    } else {
                      this.onSelectState(0, "central");
                      this.onSelectState(0, "state");
                      this.onSelectSecondary(0, "state");
                    }
                  }
                }
              }

              updateParentState("issueCOList", this.state.issueCOList);
              isEdit &&
                updateParentStateError(
                  "issueCOListError",
                  this.validateAddIssue()
                );
            }
          );
        }
      } else {
        let userID, defaultSelected;
        if (
          (workflowType === "CENTRAL" || !isProjectAwardedByState) &&
          createdBy
        ) {
          defaultSelected = `${createdBy.name} (${createdBy.userID})`;
          userID = createdBy;
        }

        this.setState({
          issueCOList: [{ defaultSelected, userID }]
        });
      }

      if (isValidArray(issueDetails)) {
        if (issueDetails[0].secondaryStateId == null) {
          this.setState({ addSecondary: true, deleteSecondary: false });
        } else this.setState({ addSecondary: false, deleteSecondary: true });
      }

      if (isValidArray(issueDetails)) {
        if (issueDetails[0].secondaryRecipientGroupId == null) {
          this.setState({
            addSecondaryState: true,
            deleteSecondaryState: false
          });
        } else
          this.setState({
            addSecondaryState: false,
            deleteSecondaryState: true
          });
      }

      if (isValidArray(issueDetails)) {
        if (issueDetails[0].secondaryMinistryId == null) {
          this.setState({
            addSecondaryForState: true,
            deleteSecondaryForState: false
          });
        } else
          this.setState({
            addSecondaryForState: false,
            deleteSecondaryForState: true
          });
      }
    }

    this.setState({
      originalProposalNo:
        (issueDetails && issueDetails[0].proposalNoParivesh) || ""
    });
  }
  componentWillReceiveProps(nextProps, nextContext) {
    const {
      params: {
        resetForm,
        stateId,
        openedFromCreateProject,
        issueDetails,
        error
      },
      issueSaved
    } = nextProps;
    if (error && error[0]) {
      this.setState({ requiredFields: error });
    }
    const { issueCOList } = this.state;
    const {
      params: { isProjectAwardedByState, parentGroupId },
      issueSaved: thisIssueSaved
    } = this.props;
    if (issueSaved) {
      this.setState({
        dataUnsaved: false
      });
    }
    if (!isProjectAwardedByState && openedFromCreateProject) {
      let selectedUser =
        typeof nextProps.params.userID !== "object"
          ? nextProps.params.createdBy
            ? nextProps.params.createdBy
            : nextProps.params.previousCreatedBy
          : nextProps.params.userID;
      if (selectedUser && selectedUser.id) {
        let _list =
          issueDetails && issueDetails.length ? issueDetails : issueCOList;
        _list.map(item => {
          item.defaultSelected = `${selectedUser.name} (${
            selectedUser.userID
          })`;
          item.userID = selectedUser;
          return item;
        });
        this.setState({
          issueCOList: _list
        });
      } else {
        let _list =
          issueDetails && issueDetails.length ? issueDetails : issueCOList;
        _list.map(item => {
          item.defaultSelected = "";
          item.userID = null;
          return item;
        });
        this.setState({
          issueCOList: _list
        });
      }
    }
    let sponseredBychanged =
      isProjectAwardedByState !== nextProps.params.isProjectAwardedByState;
    let stateChanged =
      isProjectAwardedByState &&
      parentGroupId !== nextProps.params.parentGroupId;
    let resetAddIssueFields = sponseredBychanged || stateChanged;
    let _userID, _defaultSelected;
    if (resetForm || resetAddIssueFields) {
      this.setState({
        ministryGroupList: [],
        stateGroupList: [],
        groupList: [{}],
        issueCOList:
          _defaultSelected && _userID
            ? [{ defaultSelected: _defaultSelected, userID: _userID }]
            : [{}],
        issueCOListError: [{}]
      });
    }
    if (oldStateId !== stateId) {
      if (stateId) {
      } else {
        if (oldStateId) {
          const groupListClone = [...issueCOList];
          groupListClone.forEach(value => {
            value.groupCategory = "";
          });
          this.setState({
            issueCOList: groupListClone,
            STATE: []
          });
        }
      }
      oldStateId = stateId;
    }
  }

  /**
   *
   * @param key
   * @param order
   */
  onAddField = () => {
    let {
      params: {
        workflowType,
        userID,
        createdBy,
        isProjectAwardedByState,
        initialRequiredFields
      }
    } = this.props;
    let _userID, _defaultSelected;
    let selectedUser = typeof userID !== "object" ? createdBy : userID;

    if (
      (workflowType === "CENTRAL" || !isProjectAwardedByState) &&
      selectedUser
    ) {
      _defaultSelected = `${selectedUser.name} (${selectedUser.userID})`;
      _userID = selectedUser;
    } else {
      _defaultSelected = userID ? `${userID.name} (${userID.userID})` : "";
      _userID = userID || null;
    }
    let errorArray = this.validateAddIssue();
    errorArray.push({
      error: true,
      required_field: initialRequiredFields
    });
    this.props.params.addIssueErrorUpdate(errorArray);
    this.setState(prevState => ({
      issueCOList: [
        ...prevState.issueCOList,
        { defaultSelected: _defaultSelected, userID: _userID }
      ],
      issueCOListError: [...prevState.issueCOListError, {}],
      groupList: [...prevState.groupList]
    }));
  };
  // add fields an array
  onChange = (value, key, index, list, type = "state") => {
    // console.log(value, key, index);

    const {
      params: {
        updateParentState,
        updateParentStateError,
        isProjectAwardedByState
      }
    } = this.props;
    const proposalSubCategoryValuesEdit = [
      1,
      2,
      4,
      5,
      71,
      "1",
      "2",
      "4",
      "5",
      "71"
    ];
    this.setState(prev => ({
      touched: {
        ...prev.touched,
        [`${index}-${key}`]: true
      }
    }));

    this.setState(
      prevState => {
        if (key === "recipientGroupId") {
          if (type === "state") {
            prevState.issueCOList[index]["stateDistrictAndDepartment"] = "";
            prevState.districtList[index] = "";
          } else {
            prevState.issueCOList[index]["ministryDistrictAndDepartment"] = "";
            prevState.ministryList[index] = "";
          }
        }

        if (
          key === "issueSubCategoryId" &&
          !proposalSubCategoryValuesEdit.includes(value)
        ) {
          prevState.issueCOList[index]["proposalNoParivesh"] = "";
        }

        if (key === "proposalNoParivesh") {
          this.setState({ proposalValidated: false });
        }

        if (key === "groupCategory") {
          prevState.issueCOList[index]["recipientGroupId"] = "";
          prevState.issueCOList[index]["selectedMinistryId"] = "";
          prevState.issueCOList[index]["selectedStateId"] = "";
          prevState.issueCOList[index]["ministryDistrictAndDepartment"] = "";
          prevState.issueCOList[index]["stateDistrictAndDepartment"] = "";
          prevState.districtList[index] = "";
          prevState.ministryList[index] = "";
          prevState.issueCOList[index]["secondaryStateId"] = null;
          prevState.issueCOList[index]["secondaryMinistryId"] = null;
          prevState.issueCOList[index]["secondaryStateDepartmentId"] = "";
          prevState.issueCOList[index]["secondaryMinistryDepartmentId"] = "";
          prevState.issueCOList[index]["secondaryRecipientGroup"] = null;
        }

        if (key === "title" || key === "issueDescription") {
          if (value.length > 32767) {
            value = value.slice(0, 32767);
          }
        }

        if (key === "issueCategoryId") {
          prevState.subCategoryList[index] = [];
          prevState.forumList[index] = [];
          prevState.issueCOList[index]["issueSubCategoryId"] = "";
          prevState.issueCOList[index]["forum"] = null;
          prevState.issueCOList[index]["dateOfOrder"] = null;
          prevState.issueCOList[index]["dateOfOrder"] = "";
          if (value === "11" || value === 11) {
            prevState.issueCOList[index]["ministryDistrictAndDepartment"] = "";
            prevState.issueCOList[index]["stateDistrictAndDepartment"] = "";
          }
        }

        if (key === "forum") {
          let selectedForum =
            list && list.length && list.filter(item => item.id === +value)[0];
          prevState.issueCOList[index]["forumName"] =
            selectedForum && selectedForum.name;
        }
        if (key == "reasonForEscalation") {
          if (value == "") {
            this.setState({ bordercolorBox: true });
          } else {
            this.setState({ bordercolorBox: false });
          }
          prevState.issueCOList[index]["reasonForEscalation"] = value;
          this.setState({
            escalationdropdowndisplay: false,
            escalationReason: value,
            escalationErrormessage: false
          });
        }
        if (key === "escalationLevel") {
          prevState.issueCOList[index]["escalationLevel"] = value;
          prevState.issueCOList[index]["escalationLevelName"] = list;
          //prevState.issueCOList[index]["reasonForEscalation"] = "";
          const { issueData } = this.props;
          if (issueData.data.escalationLevelName == list) {
            //prevState.issueCOList[index]["reasonForEscalation"] = issueData.data.reasonForEscalation;
            this.setState({
              selectedValue: list,
              escalationdropdowndisplay: false,
              reasonboxDisplay: false,
              escalationLevelName: list,
              escalationLevel: value,
              escalationReason: issueData.data.reasonForEscalation,
              escalationErrormessage: false,
              bordercolorBox: true
            });
          } else {
            this.setState({
              selectedValue: list,
              escalationdropdowndisplay: false,
              reasonboxDisplay: true,
              escalationLevelName: list,
              escalationLevel: value,
              escalationReason: "",
              bordercolorBox: true
            });
          }
        }
        if (key === "bucketId") {
          prevState.issueCOList[index]["milestoneTableId"] = "";
          prevState.issueCOList[index]["milestoneId"] = "";
        }

        if (key === "milestoneTableId") {
          prevState.issueCOList[index]["milestoneId"] = "";
        }

        if (key === "responsibleAuthority") {
          prevState.issueCOList[index]["responsibleAuthority"] = value;
        }

        if (key === "secondaryStateId") {
          prevState.issueCOList[index]["secondaryStateId"] = value;
          prevState.issueCOList[index]["secondaryStateDepartmentId"] = "";
          this.onSelectSecondary(index, "state");
        }

        if (key === "secondaryStateDepartmentId") {
          prevState.issueCOList[index]["secondaryStateDepartmentId"] = value;
        }

        if (key === "secondaryMinistryId") {
          prevState.issueCOList[index]["secondaryMinistryId"] = value;
          prevState.issueCOList[index]["secondaryMinistryDepartmentId"] = "";
          this.onSelectSecondary(index, "ministry");
        }

        if (key === "secondaryMinistryDepartmentId") {
          prevState.issueCOList[index]["secondaryMinistryDepartmentId"] = value;
        }

        if (key === "secondaryRecipientGroup") {
          prevState.issueCOList[index]["secondaryRecipientGroupId"] = value;
        }

        prevState.issueCOList[index][key] =
          (isValidArray(value) && value[0]) || value;

        if (key === "recipientGroupId") {
          if (type === "state") {
            prevState.issueCOList[index]["selectedStateId"] =
              (isValidArray(value) && value[0]) || value;
          } else {
            prevState.issueCOList[index]["selectedMinistryId"] =
              (isValidArray(value) && value[0]) || value;
          }
        }

        updateParentState("issueCOList", prevState.issueCOList);
        updateParentState("issueSaved", false);

        return {
          issueCOList: [...prevState.issueCOList],
          ministryList: [...prevState.ministryList],
          districtList: [...prevState.districtList],
          secondaryDistrictList: [...prevState.secondaryDistrictList],
          secondaryDepartmentList: [...prevState.secondaryDepartmentList],
          dataUnsaved: true,
          isIssueSaved: false
        };
      },
      () => {
        if (window.event.inputType === "insertFromPaste") {
          this.pasteLanguage(value, key, index);
        }
        const { issueCOList } = this.state;
        if (
          key === "recipientGroupId" &&
          issueCOList[index]["recipientGroupId"] &&
          !isProjectAwardedByState
        ) {
          this.onSelectState(index, type);
        }
        updateParentStateError("issueCOListError", this.validateAddIssue());
        if (key === "groupCategory") {
          if (isProjectAwardedByState) {
            this._getGroupByCategoryAndParentId(value);
          } else {
            this.getGroupCategoryId(value);
            if (isValidArray(value) && value[0] && value[0] === "CENTRAL") {
              this.getGroupCategoryId(["STATE"]);
            }
          }
        }

        if (key === "groupCategory" && isProjectAwardedByState) {
          this.setState({
            addSecondaryState: true,
            deleteSecondaryState: false
          });
        }

        key === "issueCategoryId" &&
          (true || issueCOList[index]["childIssue"]) &&
          this.getIssueSubCategory(value, index);
        key === "issueCategoryId" &&
          (value === "11" || value === 11) &&
          this.getIssueForum(value, index);
        if (key === "bucketId") {
          this.getPhaseTableList(value, index);
        }
        if (key === "milestoneTableId") {
          this.getMilestoneList(value, list, index);
        }
      }
    );
  };

  onRemoveFields = index => {
    const {
      params: { updateParentState, updateParentStateError }
    } = this.props;
    this.setState(
      prevState => {
        prevState.issueCOList.splice(index, 1);
        prevState.issueCOListError.splice(index, 1);
        updateParentState("issueCOList", prevState.issueCOList);
        return {
          issueCOList: [...prevState.issueCOList]
        };
      },
      () => {
        updateParentStateError("issueCOListError", this.validateAddIssue());
      }
    );
  };

  onFilesError = () => {
    toast.error(
      <p className="toast-text-alignment">Not a valid file type</p>,
      errorToastStyle
    );
    this.inValidFile = true;
  };

  onUploadFile = async (file, index) => {
    const {
      uploadFileDispatch,
      params: { updateParentState }
    } = this.props;
    const attachmentPayload = FormDataForImage(file, "file");
    attachmentPayload.append("isMis", false);
    const response = await uploadFileDispatch(undefined, attachmentPayload);
    try {
      if (!this.inValidFile) {
        if (response) {
          const { status, message, data } = response;
          if (status) {
            this.setState(prevState => {
              const files = prevState.issueCOList[index];
              prevState.issueCOList[index].files =
                prevState.issueCOList[index].files || [];
              prevState.issueCOList[index].files = [
                ...prevState.issueCOList[index].files,
                { ...files, extension: file[0].extension, ...data }
              ];
              updateParentState("issueCOList", prevState.issueCOList);
              return {
                issueCOList: [...prevState.issueCOList],
                issueCOListError: [...prevState.issueCOListError]
              };
            });
            toast.success(
              <p className="toast-text-alignment">{message}</p>,
              successToastStyle
            );
          } else {
            toast.error(
              <p className="toast-text-alignment">{message}</p>,
              errorToastStyle
            );
          }
        } else {
          toast(ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR);
        }
      }
      this.inValidFile = false;
    } catch (e) {
      toast.error(
        <p className="toast-text-alignment">{e.message}</p>,
        errorToastStyle
      );
    }
  };

  onRemoveFile = async (file, key, index, fileIndex) => {
    const {
      removeFileDispatch,
      params: { updateParentState, updateParentStateError },
      onRemoveFileDetail,
      isEdit
    } = this.props;
    const response = await removeFileDispatch(undefined, {
      fid: file.id
    });
    try {
      console.log("from try");
      if (response) {
        const { status, message } = response;
        (response.status &&
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          )) ||
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
        if (status) {
          this.setState(prevState => {
            prevState.issueCOList[index]["files"].splice(fileIndex, 1);
            updateParentState("issueCOList", prevState.issueCOList);
            updateParentStateError(
              "issueCOListError",
              prevState.issueCOListError
            );
            return {
              issueCOList: [...prevState.issueCOList],
              issueCOListError: [...prevState.issueCOListError]
            };
          });
          //this.onValidateForm();
          //console.log("isEdit", isEdit);
          if (!isEdit) {
            onRemoveFileDetail();
          }
        }
      } else {
        //console.log("from else status");
        //console.log("from else message", message)
        toast.error(
          <p className="toast-text-alignment">
            {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
          </p>,
          errorToastStyle
        );
      }
    } catch (e) {
      toast.error(
        <p className="toast-text-alignment">{e.message}</p>,
        errorToastStyle
      );
    }
  };

  //
  resetFields = index => {
    const {
      params: {
        updateParentState,
        resetIssue,
        workflowType,
        createdBy,
        isProjectAwardedByState
      }
    } = this.props;

    let _userID, _defaultSelected;
    this.setState({ resetForm: true });
    if ((workflowType === "CENTRAL" || !isProjectAwardedByState) && createdBy) {
      _defaultSelected = `${createdBy.name} (${createdBy.userID})`;
      _userID = createdBy;
    }

    this.setState(
      prevState => {
        prevState.issueCOList[index] =
          _defaultSelected && _userID
            ? {
                defaultSelected: _defaultSelected,
                userID: _userID,
                showSubcategory: true
              }
            : {};
        prevState.issueCOListError[index] = {};
        updateParentState("issueCOList", prevState.issueCOList);
        return {
          issueCOList: [...prevState.issueCOList],
          issueCOListError: [...prevState.issueCOListError]
        };
      },
      () => {
        typeof resetIssue === "function" && resetIssue(this.validateAddIssue());
      }
    );
  };

  resetMultiple = () => {
    const { issueCOList } = this.state;
    issueCOList &&
      isValidArray(issueCOList) &&
      issueCOList.map((item, index) => this.resetFields(index));
  };

  // get the issues related ministry
  //
  getGroupCategoryId = async (value, stateIdParam) => {
    const {
      params: { stateId: stateIdProps }
    } = this.props;
    const param = {
      category: value
    };

    // it will run in case of create project
    if (
      value.indexOf(GROUP_KEYS.STATE) !== -1 &&
      (stateIdParam || stateIdProps)
    ) {
      param["category"] = [GROUP_KEYS.STATE];
    }
    this.getGroupCategory(value[0], param);
  };

  getGroupCategory = async (key, param) => {
    const { issueCOList, groupList } = this.state;
    const { getGroupCategoryIdDispatch } = this.props;
    this.setState({ isGroupLoading: STATUS.LOADING });
    const response = await getGroupCategoryIdDispatch(undefined, param);
    if (response) {
      const { data, status, message } = response;
      !status &&
        toast.error(
          <p className="toast-text-alignment">
            {message} {key}is not avilable
          </p>,
          errorToastStyle
        );
      if (status) {
        const list = issueCOList.map((val, index) => {
          const newList = groupList[index];
          return { ...newList };
        });
        this.setState({
          [key]: data,
          groupList: list,
          isGroupLoading: STATUS.SUCCESS
        });
      }
    } else {
      toast(ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR);
      this.setState({ isGroupLoading: STATUS.SUCCESS });
    }
  };

  getIssueByCategory = async () => {
    const {
      getIssuesCategoryListDispatch,
      issuesCategoryList,
      params: { issueDetails }
    } = this.props;
    this.setState({ isIssueLoading: STATUS.LOADING });
    if (!isValidArray(issuesCategoryList)) {
      const resp = await getIssuesCategoryListDispatch(undefined);
      if (resp) {
        const id = get(issueDetails, "issueCategoryId");
        id && this.getIssueSubCategory(id, 0);
        id && (id === "11" || id === 11) && this.getIssueForum(id, 0);
        this.setState({ isIssueLoading: STATUS.SUCCESS });
      }
      this.setState({ isIssueLoading: STATUS.SUCCESS });
    } else {
      this.setState({ isIssueLoading: STATUS.SUCCESS });
    }
  };
  getProponentmarginTop(
    proposalNoPariveshCondition,
    reasonboxDisplay,
    escalationErrormessage
  ) {
    if (proposalNoPariveshCondition && escalationErrormessage) {
      return "-7.7em";
    } else if (proposalNoPariveshCondition && reasonboxDisplay) {
      return "-6.2em";
    } else {
      return null;
    }
  }
  getIssueSubCategory = async (id, index) => {
    const { getIssuesSubCategoryListDispatch } = this.props;
    this.setState({ isIssueSubLoading: STATUS.LOADING });
    const response = await getIssuesSubCategoryListDispatch(
      undefined,
      id && { issueCategoryId: +id }
    );
    if (response) {
      this.setState(prevState => {
        prevState.subCategoryList[index] = get(response, "data", []);
        return {
          issueCOList: [...prevState.issueCOList]
        };
      });
      this.setState({ isIssueSubLoading: STATUS.SUCCESS });
    } else {
      toast(ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR);
      this.setState({ isIssueSubLoading: STATUS.SUCCESS });
    }
  };

  getIssueForum = async (id, index) => {
    const { getForumListDispatch } = this.props;
    const response = await getForumListDispatch(+id);
    if (response) {
      this.setState(prevState => {
        prevState.forumList[index] = get(response, "data", []);
        return {
          issueCOList: [...prevState.issueCOList]
        };
      });
    } else {
      toast(ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR);
    }
  };

  getPhaseTableList = async (value, index) => {
    const {
      getMilestoneTableDataDispatch,
      params: { projectID, issueDetails } = {}
    } = this.props;
    let BucketID = value || null;
    this.setState(prevState => {
      prevState.milestoneTables[index] = [];
      prevState.milestoneLists[index] = [];
      return {
        issueCOList: [...prevState.issueCOList]
      };
    });
    try {
      const response = await getMilestoneTableDataDispatch(
        undefined,
        projectID,
        BucketID
      );
      const id =
        isValidArray(issueDetails) &&
        !!issueDetails[0] &&
        issueDetails[0].milestoneTableId;
      if (response) {
        this.setState(
          prevState => {
            prevState.milestoneTables[index] = response;
            return {
              issueCOList: [...prevState.issueCOList]
            };
          },
          () => {
            id && this.getMilestoneList(id, BucketID, 0);
          }
        );
      }
      if (value === "" && !id) {
        this.getMilestoneList(null, value);
      }
    } catch (error) {
      //console.log(error.message);
    }
  };

  getMilestoneList = async (value, bucketID, index) => {
    const {
      getMilestonesDataDispatch,
      params: { projectID } = {}
    } = this.props;
    try {
      const payload = {
        bucketId: +bucketID,
        milestoneTableId: +value,
        projectId: projectID
      };
      const response = await getMilestonesDataDispatch(undefined, payload);
      if (response) {
        this.setState(prevState => {
          prevState.milestoneLists[index] = response;
          return {
            issueCOList: [...prevState.issueCOList]
          };
        });
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // validate add issue form
  validateAddIssue = () => {
    //console.log("sucess");
    const {
      issueCOList,
      CENTRAL,
      STATE,
      districtList,
      ministryList,
      DISTRICT,
      STATE_DEPARTMENT,
      issueData
    } = this.state;
    const {
      params: {
        updateParentState,
        isProjectAwardedByState,
        isEdit,
        workflowType,
        allowOnEdit,
        allowOnCreate,
        childIssue,
        issueDetails
      }
    } = this.props;
    updateParentState("issuesProps", {
      CENTRAL,
      STATE,
      districtList,
      STATE_DEPARTMENT,
      DISTRICT
    });
    const showCreatedBy = isEdit ? !childIssue && allowOnEdit : allowOnCreate;
    const user = getLocalstorage("user");
    const subCategoryValues = ["1", "2", "4", "5", "71", 1, 2, 4, 5, 71];
    const isStatePMG = user.groupCategory === "STATE_PMG";
    const isStateDepartment = user.groupCategory === "STATE_DEPARTMENT";
    // const subCategoryValues = ["1", "4", "69", "71", 1, 4, 69, 71];
    const groupCategory = get(user, "groupCategory");
    return issueCOList.map((value, idx) => {
      const issueSubCategoryId = subCategoryValues.includes(
        value.issueSubCategoryId
      );
      let isValid, isFormFilled;
      // its added because of district
      const hasDistrictList = Boolean(
        districtList[idx] && districtList[idx].length
      );
      const hasMinistryList = Boolean(
        ministryList[idx] && ministryList[idx].length
      );
      //console.log("value.showSubcategory", value.showSubcategory);
      // if (isEdit ? value.showSubcategory : true) {
      //   mandatoryFieldsOfAddIssue.indexOf("issueSubCategoryId") === -1 &&
      //     mandatoryFieldsOfAddIssue.push("issueSubCategoryId");
      // } else {
      //   remove(mandatoryFieldsOfAddIssue, function(e) {
      //     return e === "issueSubCategoryId";
      //   });
      // }
      if (
        (value.issueCategoryId === "1" || value.issueCategoryId === 1) &&
        subCategoryValues.includes(value.issueSubCategoryId) &&
        !isProjectAwardedByState
      ) {
        mandatoryFieldsOfAddIssue.push("proposalNoParivesh");
      } else {
        remove(mandatoryFieldsOfAddIssue, function(e) {
          return e === "proposalNoParivesh";
        });
      }
      if (isEdit)
        if (isEdit) {
          if (get(user, "groupCategory") === "PMG") {
            remove(mandatoryFieldsOfAddIssue, function(e) {
              return e === "proposalNoParivesh";
            });
          } else if (
            (value.issueCategoryId === "1" || value.issueCategoryId === 1) &&
            issueSubCategoryId &&
            !isProjectAwardedByState
          ) {
            mandatoryFieldsOfAddIssue.push("proposalNoParivesh");
          }
        }

      if (value.bucketId) {
        mandatoryFieldsOfAddIssue.push("milestoneTableId");
        mandatoryFieldsOfAddIssue.push("milestoneId");
      } else {
        remove(mandatoryFieldsOfAddIssue, function(e) {
          return e === "milestoneTableId" || e === "milestoneId";
        });
      }
      if (workflowType && workflowType === "CENTRAL") {
        if (
          mandatoryFieldsOfAddIssue.indexOf("stateDistrictAndDepartment") === -1
        ) {
          mandatoryFieldsOfAddIssue.push("stateDistrictAndDepartment");
        }
      } else {
        remove(mandatoryFieldsOfAddIssue, function(e) {
          return e === "stateDistrictAndDepartment";
        });
      }
      if (get(user, "groupCategory") === "PMG" && isEdit) {
        if (this.state.issueCOList[0].groupCategory === "CENTRAL") {
          remove(mandatoryFieldsOfAddIssue, function(e) {
            return (
              e === "selectedStateId" ||
              e === "stateDistrictAndDepartment" ||
              e === "recipientGroupId"
            );
          });
        }
        if (this.state.issueCOList[0].groupCategory === GROUP_KEYS.STATE) {
          if (!mandatoryFieldsOfAddIssue.includes("selectedStateId")) {
            mandatoryFieldsOfAddIssue.push("selectedStateId");
          }
          remove(mandatoryFieldsOfAddIssue, function(e) {
            return (
              e === "stateDistrictAndDepartment" || e === "recipientGroupId"
            );
          });
        }
      }
      // ✅ ADD THIS — ensures stateDistrictAndDepartment is non-mandatory
      // for PMG in edit mode, regardless of groupCategory branch above.
      if (isEdit && get(user, "groupCategory") === "PMG") {
        remove(mandatoryFieldsOfAddIssue, function(e) {
          return e === "stateDistrictAndDepartment";
        });
      }
      if (!isEdit) {
        if (mandatoryFieldsOfAddIssue.indexOf("selectedStateId") === -1) {
          mandatoryFieldsOfAddIssue.push("selectedStateId");
        }
      }
      if (workflowType && workflowType === "CENTRAL" && showCreatedBy) {
        mandatoryFieldsOfAddIssue.indexOf("userID") === -1 &&
          mandatoryFieldsOfAddIssue.push("userID");
      } else {
        remove(mandatoryFieldsOfAddIssue, function(e) {
          return e === "userID";
        });
      }
      if (
        (isStatePMG || isStateDepartment) &&
        workflowType === "STATE" &&
        showCreatedBy
      ) {
        mandatoryFieldsOfAddIssue.indexOf("userID") === -1 &&
          mandatoryFieldsOfAddIssue.push("userID");
      } else {
        remove(mandatoryFieldsOfAddIssue, function(e) {
          return e === "userID";
        });
      }
      if (value.issueCategoryId === "11" || value.issueCategoryId === 11) {
        mandatoryFieldsOfAddIssue.indexOf("forum") === -1 &&
          mandatoryFieldsOfAddIssue.push("forum");
      } else {
        remove(mandatoryFieldsOfAddIssue, function(e) {
          return e === "forum";
        });
      }
      if (this.state.issueCOList[idx].groupCategory === GROUP_KEYS.STATE) {
        remove(mandatoryFieldsOfAddIssue, function(e) {
          return e === "selectedMinistryId";
        });
      } else {
        if (mandatoryFieldsOfAddIssue.indexOf("selectedMinistryId") === -1) {
          mandatoryFieldsOfAddIssue.push("selectedMinistryId");
        }
      }
      if (
        isProjectAwardedByState ||
        get(user, "groupCategory") === "STATE_PMG"
      ) {
        remove(mandatoryFieldsOfAddIssue, function(e) {
          return e === "selectedMinistryId";
        });
      }
      if (
        isEdit &&
        (issueDetails[0].stateDistrictAndDepartment === undefined ||
          issueDetails[0].selectedStateId === undefined) &&
        get(user, "groupCategory") !== "PMG" &&
        get(issueData, "data.issueStatus") === "UNDER_VERIFICATION"
      ) {
        mandatoryFieldsOfAddIssue.push("selectedStateId");
      }
      if (isProjectAwardedByState) {
        remove(mandatoryFieldsOfAddIssue, function(e) {
          return e === "selectedStateId" || e === "stateDistrictAndDepartment";
        });
      }
      if (
        mandatoryFieldsOfAddIssue.includes("responsibleAuthority") === false
      ) {
        mandatoryFieldsOfAddIssue.push("responsibleAuthority");
      }
      if (
        isEdit &&
        (get(user, "groupCategory") === "PMG" ||
          get(user, "groupCategory") === "STATE_PMG")
      ) {
        remove(mandatoryFieldsOfAddIssue, function(e) {
          return e === "responsibleAuthority";
        });
      }
      const newValidateArr = [...mandatoryFieldsOfAddIssue];
      let req_fields = [];
      isValid = true;
      for (let key in newValidateArr) {
        if (!Object.keys(value).length) {
          isValid = true;
          isFormFilled = false;
          break;
        }
        isFormFilled = true;
        let fieldName = newValidateArr[key];
        // if (!value[fieldName]) {
        //   isValid = false;
        //   req_fields.push(fieldName);
        // }
        let fieldValue = value[fieldName];
        if (fieldName === "issueDescription") {
          if (this.isQuillEmpty(fieldValue)) {
            isValid = false;
            req_fields.push(fieldName);
          }
        } else {
          if (!fieldValue) {
            isValid = false;
            req_fields.push(fieldName);
          }
        }

        if (
          newValidateArr[key] === "issueCategoryId" &&
          !value["issueCategoryId"] &&
          !value["issueSubCategoryId"] &&
          req_fields.includes("issueSubCategoryId") === false
        ) {
          req_fields.push("issueSubCategoryId");
        }
        if (
          newValidateArr[key] === "issueSubCategoryId" &&
          value["issueCategoryId"] &&
          value["issueSubCategoryId"] &&
          req_fields.includes("issueSubCategoryId") === true
        ) {
          req_fields.remove("issueSubCategoryId");
        }
      }
      return isFormFilled
        ? isValid
          ? { error: false }
          : { error: true, required_field: req_fields }
        : {};
    });
  };

  onAutoSuggestChangeState = (value, idx) => {
    const {
      params: { updateParentState, updateParentStateError }
    } = this.props;
    this.setState(prevState => {
      prevState.issueCOList[idx]["defaultSelected"] = value.searchedText;
      prevState.issueCOList[idx]["userID"] = value.searchedText;
      return {
        autoSuggestApiLoading: STATUS.LOADING,
        issueCOList: [...prevState.issueCOList],
        options: []
      };
    });
    get(this.autoSuggestApi, "cancel") && this.autoSuggestApi.cancel();
    this.autoSuggestApi = debounce(async () => {
      const resp = await getAutoCompleteListUserAction(
        undefined,
        value.searchedText
      );
      if (resp) {
        if (get(resp, "status") && isValidArray(get(resp, "data"))) {
          this.setState(prevState => {
            prevState.issueCOList[idx]["defaultSelected"] = value.searchedText;
            return {
              options: get(resp, "data"),
              defaultSelected: "",
              autoSuggestApiLoading: STATUS.SUCCESS,
              issueCOList: [...prevState.issueCOList]
            };
          });
        } else {
          toast.error(
            <p className="toast-text-alignment">{ERROR_MSG.NO_DATA_FOUND}</p>,
            errorToastStyle
          );
          this.setState(prevState => {
            prevState.issueCOList[idx]["defaultSelected"] = "";
            return {
              options: [],
              autoSuggestApiLoading: STATUS.SUCCESS,
              issueCOList: [...prevState.issueCOList]
            };
          });
        }
      } else {
        toast.error(
          <p className="toast-text-alignment">{ERROR_MSG.NO_DATA_FOUND}</p>,
          errorToastStyle
        );
        this.setState(prevState => {
          prevState.issueCOList[idx]["defaultSelected"] = "";
          return {
            options: [],
            autoSuggestApiLoading: STATUS.SUCCESS,
            issueCOList: [...prevState.issueCOList]
          };
        });
      }
      updateParentState("issueCOList", this.state.issueCOList);
      updateParentStateError("issueCOListError", this.validateAddIssue());
    }, 1000);
    this.autoSuggestApi();
  };

  onAutoSuggestChange = (value, idx) => {
    const {
      params: { updateParentState, updateParentStateError }
    } = this.props;
    this.setState(prevState => {
      prevState.issueCOList[idx]["defaultSelected"] = value.searchedText;
      prevState.issueCOList[idx]["userID"] = value.searchedText;
      return {
        autoSuggestApiLoading: STATUS.LOADING,
        issueCOList: [...prevState.issueCOList],
        options: []
      };
    });
    get(this.autoSuggestApi, "cancel") && this.autoSuggestApi.cancel();
    this.autoSuggestApi = debounce(async () => {
      const resp = await getAutoCompleteListAction(
        undefined,
        value.searchedText
      );
      if (resp) {
        if (get(resp, "status") && isValidArray(get(resp, "data"))) {
          this.setState(prevState => {
            prevState.issueCOList[idx]["defaultSelected"] = value.searchedText;
            return {
              options: get(resp, "data"),
              defaultSelected: "",
              autoSuggestApiLoading: STATUS.SUCCESS,
              proponentErrormsg: false,
              issueCOList: [...prevState.issueCOList]
            };
          });
        } else {
          toast.error(
            <p className="toast-text-alignment">{ERROR_MSG.NO_DATA_FOUND}</p>,
            errorToastStyle
          );
          this.setState(prevState => {
            prevState.issueCOList[idx]["defaultSelected"] = "";
            return {
              options: [],
              autoSuggestApiLoading: STATUS.SUCCESS,
              issueCOList: [...prevState.issueCOList]
            };
          });
        }
      } else {
        toast.error(
          <p className="toast-text-alignment">{ERROR_MSG.NO_DATA_FOUND}</p>,
          errorToastStyle
        );
        this.setState(prevState => {
          prevState.issueCOList[idx]["defaultSelected"] = "";
          return {
            options: [],
            autoSuggestApiLoading: STATUS.SUCCESS,
            issueCOList: [...prevState.issueCOList]
          };
        });
      }
      updateParentState("issueCOList", this.state.issueCOList);
      updateParentStateError("issueCOListError", this.validateAddIssue());
    }, 1000);
    this.autoSuggestApi();
  };

  onOptionClick = (value, idx) => {
    const {
      params: { updateParentState, updateParentStateError }
    } = this.props;
    this.setState(
      prevState => {
        prevState.issueCOList[idx]["userID"] = value;
        prevState.issueCOList[idx]["defaultSelected"] = `${value.name} (${
          value.userID
        })`;
        return {
          issueCOList: [...prevState.issueCOList],
          options: [],
          dataUnsaved: true,
          isIssueSaved: false,
          proponentErrormsg: false
        };
      },
      () => {
        updateParentState("issueCOList", this.state.issueCOList);
        updateParentStateError("issueCOListError", this.validateAddIssue());
      }
    );
  };
  onOptionClickForState = (value, idx) => {
    const {
      params: { updateParentState, updateParentStateError }
    } = this.props;
    this.setState(
      prevState => {
        prevState.issueCOList[idx]["userID"] = value;
        prevState.issueCOList[idx]["defaultSelected"] = `${value.name} (${
          value.organizationGroup
        })`;
        return {
          issueCOList: [...prevState.issueCOList],
          options: [],
          dataUnsaved: true,
          isIssueSaved: false
        };
      },
      () => {
        updateParentState("issueCOList", this.state.issueCOList);
        updateParentStateError("issueCOListError", this.validateAddIssue());
      }
    );
  };
  onSelectStateProps = async idx => {};
  onSelectState = async (idx, type = "state") => {
    const { issueCOList } = this.state;
    const {
      recipientGroupParentId,
      childIssue,
      selectedStateId,
      selectedMinistryId,
      secondaryStateId
    } = issueCOList[idx] || {};
    //console.log(issueCOList,idx)
    const {
      params: { updateParentStateError }
    } = this.props;
    try {
      let id = null;
      if (childIssue) {
        id = recipientGroupParentId;
      } else if (type === "state") {
        id = selectedStateId;
      } else {
        id = selectedMinistryId;
      }
      let tempBool =
        this.state.issueCOList[0].groupCategory == "STATE" ? true : false;
      const resp = await getDistrictAndDepartmentIssues(
        undefined,
        id,
        false,
        tempBool
      );
      if (resp) {
        const { data, status } = resp;
        if (status) {
          this.setState(
            prevState => {
              let returnData = {
                issueCOList: [...prevState.issueCOList]
              };

              if (type === "state") {
                prevState.districtList[idx] = get(data, "data", []);
                returnData.districtList = [...prevState.districtList];
                return returnData;
              }

              prevState.ministryList[idx] = get(data, "data", []);
              returnData.ministryDepartmentList = [...prevState.districtList];
              return returnData;
            },
            () => {
              this.validateAddIssue();
              updateParentStateError(
                "issueCOListError",
                this.validateAddIssue()
              );
            }
          );
        }
      }
    } catch (err) {
      //.log("Error of select district -", err.message);
    }
  };

  onSelectSecondary = async (idx, type = "state") => {
    const { issueCOList } = this.state;
    const { secondaryStateId, secondaryMinistryId } = issueCOList[idx] || {};

    const {
      params: { updateParentStateError }
    } = this.props;
    try {
      let id = type == "state" ? secondaryStateId : secondaryMinistryId;

      const resp = await getDistrictAndDepartmentIssues(
        undefined,
        id,
        false,
        true
      );
      if (resp) {
        const { data, status } = resp;
        if (status) {
          this.setState(
            prevState => {
              let returnData = {
                issueCOList: [...prevState.issueCOList]
              };
              if (secondaryStateId) {
                prevState.secondaryDistrictList[idx] = get(data, "data", []);
                returnData.secondaryDistrictList = [
                  ...prevState.secondaryDistrictList
                ];
                return returnData;
              }
              if (secondaryMinistryId) {
                prevState.secondaryDepartmentList[idx] = get(data, "data", []);
                returnData.secondaryDepartmentList = [
                  ...prevState.secondaryDepartmentList
                ];
                return returnData;
              }
            },
            () => {
              this.validateAddIssue();
              updateParentStateError(
                "issueCOListError",
                this.validateAddIssue()
              );
            }
          );
        }
      }
    } catch (err) {}
  };

  onSelectCentral = async idx => {
    const { issueCOList } = this.state;
    const {
      groupCategory,
      recipientGroupId,
      recipientGroupParentId,
      childIssue
    } = issueCOList[idx] || {};

    try {
      if (
        [
          GROUP_KEYS.STATE_DEPARTMENT,
          GROUP_KEYS.STATE,
          GROUP_KEYS.DISTRICT
        ].includes(groupCategory) &&
        (recipientGroupId || recipientGroupParentId)
      ) {
        this.setState(prevState => {
          prevState.districtList[idx] = [];
          return {
            districtList: [...prevState.districtList]
          };
        });
        let id = childIssue ? recipientGroupParentId : recipientGroupId;
        const resp = await getDistrictAndDepartmentIssues(undefined, id);
        if (resp) {
          const { data, status } = resp;
          if (status && isValidArray(get(data, "data"))) {
            this.setState(prevState => {
              prevState.districtList[idx] = get(data, "data");
              return {
                districtList: [...prevState.districtList]
              };
            });
          } else {
            toast.error(
              <p className="toast-text-alignment">
                No data found of districts
              </p>,
              errorToastStyle
            );
          }
        }
      } else {
        toast.error(
          <p className="toast-text-alignment">No data found</p>,
          errorToastStyle
        );
        this.setState(prevState => {
          prevState.districtList[idx] = [];
          return {
            districtList: [...prevState.districtList]
          };
        });
      }
    } catch (err) {
      //console.log("Error of select district -", err.message);
    }
  };

  // uploded comes tru in case of file
  // is uploaded
  onToggleAttachment = index => {
    this.sectionId = index;
    this.setState(prevState => {
      return {
        toggleAttachementDisplay: !prevState.toggleAttachementDisplay
      };
    });
  };

  onSuccessUploadOfAttachmets = async data => {
    try {
      const {
        params: { updateParentState }
      } = this.props;

      this.setState(prevState => {
        const issueCOList = prevState.issueCOList[this.sectionId];
        issueCOList.files = issueCOList.files || [];
        issueCOList.files = [...issueCOList.files, data];
        updateParentState("issueCOList", prevState.issueCOList);
        return {
          issueCOList: [...prevState.issueCOList],
          issueCOListError: [...prevState.issueCOListError]
        };
      });
    } catch (error) {
      //console.error(error.message);
    }
  };

  _getGroupByCategoryAndParentId = async value => {
    const { issueCOList, groupList } = this.state;
    const {
      getGroupByCategoryAndParentId,
      params: { parentGroupId }
    } = this.props;
    const param = {
      category: isValidArray(value) && value[0],
      parentId: +parentGroupId
    };
    this.setState({ isGroupLoading: STATUS.LOADING });
    const response = await getGroupByCategoryAndParentId(undefined, param);
    if (response) {
      const { data, status, message } = response;
      !status &&
        toast.error(
          <p className="toast-text-alignment">
            {message}Issue In Fetching Data
          </p>,
          errorToastStyle
        );
      if (status) {
        const list = issueCOList.map((val, index) => {
          const newList = groupList[index];
          return { ...newList };
        });
        this.setState({
          [value]: data,
          groupList: list,
          isGroupLoading: STATUS.SUCCESS
        });
      }
    } else {
      toast(ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR);
      this.setState({ isGroupLoading: STATUS.SUCCESS });
    }
  };

  // Get Milestone Buckets List
  getBucketsData = async () => {
    const {
      getBucketListDispatch,
      params: { projectID, issueDetails } = {}
    } = this.props;
    try {
      const response = await getBucketListDispatch(undefined, projectID);
      if (response) {
        const id =
          isValidArray(issueDetails) &&
          !!issueDetails[0] &&
          issueDetails[0].bucketId;
        id && this.getPhaseTableList(id, 0);
      }
    } catch (error) {
      //console.log(error.message);
    }
  };
  setRequiredFieldsInState() {
    let issueCOListError = this.props.params.errorCOListError;

    if (!issueCOListError || !issueCOListError.length) {
      return [];
    }

    this.setState({
      requiredFields: issueCOListError
    });
  }

  // showInputFieldErrorMessage(key, idx) {
  //   const { requiredFields } = this.state;
  //   if (
  //     requiredFields &&
  //     requiredFields[idx] &&
  //     requiredFields[idx].required_field &&
  //     requiredFields[idx].required_field.includes(key)
  //   ) {
  //     return (
  //       <Form.Control.Feedback type="invalid">
  //         This field is required.
  //       </Form.Control.Feedback>
  //     );
  //   }
  //   //return <></>;
  // }
  showInputFieldErrorMessage(key, idx) {
    const { requiredFields, touched = {}, formSubmitted } = this.state;
    const fieldKey = `${idx}-${key}`;

    const isRequired =
      requiredFields &&
      requiredFields[idx] &&
      requiredFields[idx].required_field &&
      requiredFields[idx].required_field.includes(key);

    if (isRequired && (touched[fieldKey] || formSubmitted)) {
      return (
        <Form.Control.Feedback type="invalid">
          This field is required.
        </Form.Control.Feedback>
      );
    }

    return null;
  }

  showVideoPlayerModal() {
    const { showVideoPlayer, videoUrl, videoTitle } = this.state;
    return (
      <VideoPlayerModal
        showVideoModal={showVideoPlayer}
        url={videoUrl}
        videoTitle={videoTitle}
        onClose={() =>
          this.setState({
            showVideoPlayer: false,
            videoUrl: null,
            videoTitle: null
          })
        }
      />
    );
  }

  inputLanguage = (event, idx) => {
    const { issueData, params } = this.props;
    if (window.event.inputType !== "insertFromPaste") {
      if (
        !params.isProjectAwardedByState ||
        !event.target.value.match(/[\u0900-\u097F]/)
      ) {
        let hasInputValue = handleLanguage(event);
        this.setState({
          languageError: hasInputValue,
          onPasteError: false,
          key: event.target.id,
          indexOfInputField: idx,
          pastedText: event.target.value
        });
      } else {
        this.setState({
          languageError: false,
          onPasteError: false,
          key: event.target.id,
          indexOfInputField: idx,
          pastedText: event.target.value
        });
      }
    }
    if (window.event.inputType === "insertFromPaste") {
      this.pasteLanguage(event.target.value, event.target.id, idx);
    }
  };

  pasteLanguage = (value, key, index) => {
    const { issueData, params } = this.props;
    if (!params.isProjectAwardedByState || !value.match(/[\u0900-\u097F]/)) {
      let { filterString, hasBadValue } = handlePaste(value);
      console.log(filterString, hasBadValue);
      this.setState({
        pastedText: filterString,
        onPasteError: hasBadValue,
        key: key,
        indexOfInputField: index
      });

      // Only update Quill editor directly — not state value binding
      if (this.reactQuillRef && key == "issueDescription") {
        const editor = this.reactQuillRef.getEditor();
        editor.clipboard.dangerouslyPasteHTML(filterString);
      }
    } else {
      this.setState({
        pastedText: value,
        key: key,
        indexOfInputField: index
      });
    }
  };
  showingErroMessage = (key, idx) => {
    const { languageError, onPasteError } = this.state;
    const { showLanguageError, isEdit } = this.props;
    if (
      key === true &&
      (languageError === true || onPasteError === true) &&
      showLanguageError === true
    ) {
      return (
        <div className="warning">
          <Image src={CircleWithExclamation} />
          Only English language is supported.
        </div>
      );
    }
  };
  onValidateForm = async () => {
    this.setState({ formSubmitted: true });
    const user = getLocalstorage("user");
    const isPMG = user.groupCategory === "PMG";
    const { onValidateForm, params } = this.props;
    const {
      params: { isEdit }
    } = this.props;
    const { issueCOList } = this.state;
    console.log("issueCOList", issueCOList);
    if (
      issueCOList[0].userID == "" &&
      isPMG &&
      issueCOList[0].groupCategory == "CENTRAL"
    ) {
      this.setState({ proponentErrormsg: true });
      toast.error(
        <p className="toast-text-alignment">Mandatory fields are missing</p>,
        errorToastStyle
      );
    }

    if (
      !isEdit &&
      !params.isProjectAwardedByState &&
      (!issueCOList[0].proposalNoParivesh ||
        issueCOList[0].proposalNoParivesh.trim() === "")
    ) {
      onValidateForm();
      return;
    } else if (
      !isEdit &&
      !params.isProjectAwardedByState &&
      issueCOList[0].proposalNoParivesh != "" &&
      this.state.proposalValidated
    ) {
      onValidateForm();
    } else if (
      !isEdit &&
      !params.isProjectAwardedByState &&
      issueCOList[0].proposalNoParivesh != "" &&
      !this.state.proposalValidated
    ) {
      if (this.state.proposalErrorMessage !== "") {
        if (
          !(issueCOList && issueCOList[0] && issueCOList[0].title) ||
          !(issueCOList && issueCOList[0] && issueCOList[0].issueDescription)
        ) {
          onValidateForm();
        } else {
          toast.error(
            <p className="toast-text-alignment">
              Mandatory fields are missing
            </p>,
            errorToastStyle
          );
        }
      } else onValidateForm();
    } else if (isEdit && !params.isProjectAwardedByState) {
      const original = this.state.originalProposalNo;
      const current = issueCOList[0].proposalNoParivesh;
      const userGroup = get(user, "groupCategory");
      // user changed proposal number
      if (original !== current && userGroup !== "PMG") {
        if (!this.state.proposalValidated) {
          toast.error(
            <p className="toast-text-alignment">
              Mandatory fields are missing
            </p>,
            errorToastStyle
          );
          return;
        }
      }
      onValidateForm();
    } else if (this.state.escalationReason == null) {
      onValidateForm();
    } else {
      const trimmedReason = this.state.escalationReason.trim();
      const regex = /^\s*$/;
      if (this.state.escalationLevelName == "") {
        onValidateForm();
      } else if (
        this.state.escalationReason == "" ||
        regex.test(trimmedReason)
      ) {
        //console.log("errorr");
        this.setState({ escalationErrormessage: true, bordercolorBox: true });
        toast.error(
          <p className="toast-text-alignment">Mandatory fields are missing</p>,
          errorToastStyle
        );
        if (
          issueCOList[0].title == "" ||
          issueCOList[0].issueDescription == "" ||
          issueCOList[0].issueDescription == "<p><br></p>"
        ) {
          onValidateForm();
        }
        //onValidateForm();
      } else if (issueCOList[0].issueDescription == "<p><br></p>") {
      } else {
        console.log("success");
        onValidateForm();
      }
    }
  };

  handleAdd = () => {
    this.setState({
      addSecondary: false,
      deleteSecondary: true,
      addSecondaryState: false,
      deleteSecondaryState: true
    });
  };

  handleDelete = () => {
    const { issueCOList } = this.state;
    this.setState({
      addSecondary: true,
      deleteSecondary: false,
      addSecondaryState: true,
      deleteSecondaryState: false
    });

    if (
      issueCOList[0].secondaryStateId ||
      issueCOList[0].secondaryStateDepartmentId
    ) {
      issueCOList[0].secondaryStateId = null; // Hide delete button
      issueCOList[0].secondaryStateDepartmentId = null;
      this.setState({ ...issueCOList });
    }
    if (issueCOList[0].secondaryRecipientGroupId) {
      issueCOList[0].secondaryRecipientGroupId = null;
      issueCOList[0].secondaryRecipientGroup = null;
      this.setState({ ...issueCOList });
    }
  };

  handleAddForState = () => {
    this.setState({
      addSecondaryForState: false,
      deleteSecondaryForState: true
    });
  };

  handleDeleteForState = () => {
    const { issueCOList } = this.state;
    this.setState({
      addSecondaryForState: true,
      deleteSecondaryForState: false
    });

    if (
      issueCOList[0].secondaryMinistryId ||
      issueCOList[0].secondaryMinistryDepartmentId
    ) {
      issueCOList[0].secondaryMinistryId = null; // Hide delete button
      issueCOList[0].secondaryMinistryDepartmentId = null;
      this.setState({ ...issueCOList });
    }
  };

  onModelSelect = () => {
    const {
      ministryList,
      issueCOList,
      STATE,
      districtList,
      subCategoryList,
      milestoneLists,
      milestoneTables,
      CENTRAL,
      DISTRICT,
      STATE_DEPARTMENT,
      CENTRAL_DEPARTMENT,
      OTHER,
      INDUSTRIAL
    } = this.state;
    //console.log(CENTRAL)
    this.props.params.prevPage(
      issueCOList,
      true,
      ministryList,
      STATE,
      districtList,
      subCategoryList,
      milestoneLists,
      milestoneTables,
      CENTRAL,
      DISTRICT,
      STATE_DEPARTMENT,
      CENTRAL_DEPARTMENT,
      OTHER,
      INDUSTRIAL
    );
    //console.log(ministryList)
  };

  handleChange = (html, delta, source, editor, key, index) => {
    // let cleanHtml = html
    //   .replace(/^(<p><br><\/p>)+/g, '')
    //   .replace(/(<p><br><\/p>){2,}/g, '<p><br></p>');
    this.onQuillChange(html, delta, source, editor, "issueDescription", index);
  };
  onQuillChange = (
    value,
    delta,
    source,
    editor,
    key,
    index,
    list,
    type = "state"
  ) => {
    const {
      params: {
        updateParentState,
        updateParentStateError,
        isProjectAwardedByState
      }
    } = this.props;
    const proposalSubCategoryValuesEdit = [1, 4, 69, 71, "1", "4", "69", "71"];

    this.setState(
      prevState => {
        if (key === "title" || key === "issueDescription") {
          if (value.length > 32767) {
            value = value.slice(0, 32767);
          }
        }

        prevState.issueCOList[index][key] =
          (isValidArray(value) && value[0]) || value;

        updateParentState("issueCOList", prevState.issueCOList);
        updateParentState("issueSaved", false);

        return {
          issueCOList: [...prevState.issueCOList],
          ministryList: [...prevState.ministryList],
          districtList: [...prevState.districtList],
          dataUnsaved: true,
          isIssueSaved: false,
          pastedText: value === "" ? "" : prevState.pastedText
        };
      },
      () => {
        // 🔹 Detect paste inside React Quill
        if (source === "user" && delta && delta.ops) {
          const isPaste = delta.ops.some(
            op => op.insert && op.insert.length > 1
          );
          if (isPaste) {
            console.log("Is pasted");
            this.pasteLanguage(value, key, index);
          }
        }

        updateParentStateError("issueCOListError", this.validateAddIssue());
      }
    );
  };

  isQuillEmpty = html => {
    if (!html) return true;
    const text = html.replace(/<(.|\n)*?>/g, "").trim(); // remove all tags
    return text === "";
  };
  // IsValidProposal = (proposalNoParivesh) => {
  //   if (this.state.proposalValidated && proposalNoParivesh != "") {
  //     return (<Form.Control.Feedback type="invalid">
  //       Invalid Proposal
  //     </Form.Control.Feedback>)
  //   }
  //   else {
  //     return (<Form.Control.Feedback type="invalid">
  //       Please Validate the Proposal Number
  //     </Form.Control.Feedback>)
  //   }
  // }

  handleProposalValidation = async (subCategoryId, proposalID, idx) => {
    const {
      params: { updateParentState },
      handleProposalChange
    } = this.props;
    const data = {
      subCategoryId: subCategoryId,
      proposalId: proposalID
    };
    if (proposalID == "" || proposalID == undefined) {
      this.setState({
        proposalErrorMessage: "This Field is required."
      });
    } else {
      handleProposalChange(true);
      const response = await proposalDetailValidation(undefined, data);
      if (response.status) {
        toast.success(
          <p className="toast-text-alignment">{"Validated Successfully"}</p>,
          successToastStyle
        );
        this.setState({
          proposalValidated: response.status,
          proposalErrorMessage: ""
        });
        handleProposalChange(false);
      } else {
        toast.error(
          <p className="toast-text-alignment">
            {"Invalid Proposal or Proposal Type"}
          </p>,
          errorToastStyle
        );
        this.setState({
          proposalErrorMessage: "Invalid Proposal or Proposal Type"
        });
        handleProposalChange(false);
      }

      this.setState(prevState => {
        if (this.state.proposalValidated) {
          prevState.issueCOList[idx][
            "proposalNoValidated"
          ] = this.state.proposalValidated;
        }
        // else prevState.issueCOList[idx]["proposalNoValidated"] = false;

        updateParentState("issueCOList", prevState.issueCOList);
        return {
          issueCOList: [...prevState.issueCOList]
        };
      });
    }
  };

  checkForValidationProposal = proposalValidated => {
    const { params } = this.props;
    if (proposalValidated !== "" && !params.isProjectAwardedByState) {
      if (!this.state.proposalValidated) {
        this.setState({
          proposalErrorMessage: "Please Validate the Proposal Number"
        });
      }
    } else if (params.isProjectAwardedByState) {
      this.setState({
        proposalErrorMessage: ""
      });
    } else {
      this.setState({
        proposalErrorMessage: "This Field is required."
      });
    }
  };

  proponentBlur = value => {};
  render() {
    const {
      props: {
        showLanguageError,
        params: {
          error,
          errorCOListError,
          isEdit,
          isProjectAwardedByState,
          selectedOptionImageUrl,
          allowOnEdit,
          allowOnCreate,
          allowPrompt = true,
          projectPPList,
          childIssue,
          openedFromCreateProject,
          issueFormType,
          issueData,
          issueDetails,
          showModal,
          prevPage
        },
        issuesCategoryList,
        history,
        bucketList,
        bucketListStatus,
        milestoneTableStatus,
        milestoneDataListStatus,
        issueCOListData,
        backButtonPress
      },
      state: {
        CENTRAL,
        STATE,
        DISTRICT,
        STATE_DEPARTMENT,
        CENTRAL_DEPARTMENT,
        OTHER,
        INDUSTRIAL,
        options,
        issueCOList,
        ministryList,
        districtList,
        secondaryDistrictList,
        secondaryDepartmentList,
        isGroupLoading,
        isIssueLoading,
        subCategoryList,
        forumList,
        isIssueSubLoading,
        autoSuggestApiLoading,
        toggleAttachementDisplay,
        dataUnsaved,
        milestoneTables,
        milestoneLists,
        canUploadVideo,
        languageError,
        onPasteError,
        pastedText,
        indexOfInputField,
        Escalationarr,
        escalationdropdowndisplay,
        selectedValue,
        reasonboxDisplay,
        escalationErrormessage,
        escalationReason,
        bordercolorBox,
        proponentErrormsg
      },
      onToggleAttachment,
      onSuccessUploadOfAttachmets
    } = this;
    this.setRequiredFieldsInState();
    const showCreatedBy = isEdit ? allowOnEdit : allowOnCreate;
    const proposalSubCategoryValues = [
      "1",
      "2",
      "4",
      "5",
      "71",
      1,
      2,
      4,
      5,
      71
    ];
    const proposalSubCategoryValuesEdit = [
      1,
      2,
      4,
      5,
      71,
      "1",
      "2",
      "4",
      "5",
      "71"
    ];
    const isFormTypeNotDefault = isEdit && issueFormType === "PP";
    const user = getLocalstorage("user");
    const isStatePMG = user.groupCategory === "STATE_PMG";
    const isStateDepartment = user.groupCategory === "STATE_DEPARTMENT";
    let extension = "";
    //console.log("from AddIssueForm", backButtonPress);

    const toolbarConfig = {
      toolbar: [["bold", "italic"], [{ list: "ordered" }, { list: "bullet" }]]
    };
    const formats = [
      "header",
      "font",
      "size",
      "bold",
      "italic",
      "underline",
      "strike",
      "blockquote",
      "list",
      "bullet",
      "indent",
      "link",
      "image",
      "video"
    ];

    return (
      <React.Fragment>
        {this.state.showVideoPlayer === true && this.showVideoPlayerModal()}
        <Prompt
          when={dataUnsaved && allowPrompt}
          message={location => {
            return location.pathname === (history && history.location.pathname)
              ? true
              : "You have unsaved changes, are you sure you want to leave?";
          }}
        />
        {toggleAttachementDisplay ? (
          <UploadAttachmentsWithTitleComponent
            displayModal={toggleAttachementDisplay}
            onCloseModal={onToggleAttachment}
            fileFormats={FILE_FORMATS}
            onSubmit={onSuccessUploadOfAttachmets}
            canUploadVideo={canUploadVideo}
          />
        ) : null}
        <div
          className={
            isEdit ? "create-issue-wrapper-edit" : "create-issue-wrapper"
          }
        >
          {(isValidArray(issueCOList) &&
            issueCOList.map((val, idx) => {
              let issueId = `issue-${idx}`;
              const currentError = isEdit
                ? error && error[idx]
                : error &&
                  error[idx] &&
                  errorCOListError &&
                  errorCOListError[idx];
              const list =
                (val.groupCategory === GROUP_KEYS.CENTRAL && CENTRAL) ||
                (val.groupCategory === GROUP_KEYS.STATE && STATE) ||
                (val.groupCategory === GROUP_KEYS.STATE_DEPARTMENT &&
                  STATE_DEPARTMENT) ||
                (val.groupCategory === GROUP_KEYS.DISTRICT && DISTRICT) ||
                (val.groupCategory === GROUP_KEYS.CENTRAL_DEPARTMENT &&
                  CENTRAL_DEPARTMENT) ||
                (val.groupCategory === GROUP_KEYS.OTHER && OTHER) ||
                (val.groupCategory === GROUP_KEYS.INDUSTRIAL && INDUSTRIAL) ||
                [];
              const secondaryStateDeptDistrict =
                (val.groupCategory === GROUP_KEYS.DISTRICT &&
                  STATE_DEPARTMENT) ||
                (val.groupCategory === GROUP_KEYS.STATE_DEPARTMENT &&
                  DISTRICT) ||
                [];
              const listSecondary =
                (val.groupCategory !== GROUP_KEYS.CENTRAL && CENTRAL) ||
                (val.groupCategory !== GROUP_KEYS.STATE && STATE) ||
                [];
              const stateOptions = STATE;
              const proposalNoPariveshCondition =
                ((val.issueCategoryId === "1" || val.issueCategoryId === 1) &&
                  proposalSubCategoryValues.includes(val.issueSubCategoryId)) ||
                (val.issueCategoryId === 1 &&
                  (proposalSubCategoryValuesEdit.includes(
                    val.issueSubCategoryId
                  ) ||
                    proposalSubCategoryValues.includes(
                      val.issueSubCategoryId
                    )) &&
                  !isProjectAwardedByState &&
                  isEdit);
              const subCategoryArr = subCategoryList[idx] || [];
              const forumArr = forumList[idx] || [];
              const defaultSelected = val.defaultSelected;
              const ministryOptions = ministryList[idx];
              const districtOptions = districtList[idx];
              const secondarydistrictOptions = secondaryDistrictList[idx];
              const secondaryDepartmentOptions = secondaryDepartmentList[idx];
              const ministryDistrictAndDepartment =
                val.ministryDistrictAndDepartment;
              const stateDistrictAndDepartment = val.stateDistrictAndDepartment;
              const secondaryStateDepartmentId = val.secondaryStateDepartmentId;
              const forum = val.forum;
              const dateOfOrder = val.dateOfOrder;
              const milesTableListArr = milestoneTables[idx] || [];
              const milestoneListsArr = milestoneLists[idx] || [];
              let name;
              get(val, "files", []).map(value => {
                if (value) {
                  extension = value.name.substr(
                    value.name.lastIndexOf(".") + 1,
                    value.name.length
                  );
                  name = value.name.substr(0, value.name.lastIndexOf(".") - 1);
                }
              });
              let createClassName;
              if (isEdit) {
                createClassName = "edit-issue-form";
              } else if (showModal) {
                createClassName = "create-issue-form-model";
              } else {
                createClassName = "create-issue-form";
              }
              return (
                <div
                  key={idx}
                  className={`${createClassName}  ${
                    get(currentError, "error") ||
                    this.state.proposalErrorMessage != ""
                      ? "error-field"
                      : ""
                  } ${(idx === 0 && "first-issue") || ""}`}
                >
                  {isEdit ? (
                    <div onClick={this.handleDisplayDropdown}>
                      <h2 className="page-heading">Edit Issue</h2>
                      {isProjectAwardedByState ? (
                        <p className="page-subline">
                          One issue can be tagged to one only
                          District/Department at a time. For tagging another
                          District/Department, raise a new issue after
                          submitting the form
                        </p>
                      ) : (
                        <p className="page-subline">
                          One issue can be tagged to one only Ministry/State at
                          a time. For tagging another Ministry/State, raise a
                          new issue after submitting the form
                        </p>
                      )}
                    </div>
                  ) : null}
                  <Form.Row>
                    {val.groupCategory === GROUP_KEYS.CENTRAL_DEPARTMENT ||
                    val.groupCategory === "OTHER" ||
                    val.groupCategory === "INDUSTRIAL" ||
                    isFormTypeNotDefault ? null : (
                      <Form.Group
                        className="field-checkbox field-issue-related-to"
                        as={Col}
                        md="12"
                        controlId="issueRelated"
                        onClick={this.handleDisplayDropdown}
                      >
                        <Form.Label>
                          Issue Recipient
                          <span className="required">*</span>
                        </Form.Label>
                        <div className="form-field">
                          {isProjectAwardedByState ? (
                            <React.Fragment>
                              <Form.Check
                                className={`form-checkbox ${[
                                  GROUP_KEYS.DISTRICT
                                ].includes(val.groupCategory) && "checked"}`}
                              >
                                <Form.Check.Input
                                  type="radio"
                                  name="related-issue"
                                />
                                <Form.Text
                                  className="form-checkbox-label"
                                  onClick={() => {
                                    this.onChange(
                                      [GROUP_KEYS.DISTRICT],
                                      "groupCategory",
                                      idx
                                    );
                                  }}
                                >
                                  {selectedOptionImageUrl ? (
                                    <div className="checkbox-image">
                                      <Image
                                        src={selectedOptionImageUrl}
                                        alt="India Map"
                                      />
                                    </div>
                                  ) : null}
                                  <div className="checkbox-text">District</div>
                                </Form.Text>
                              </Form.Check>
                              <Form.Check
                                className={`form-checkbox ${[
                                  GROUP_KEYS.STATE_DEPARTMENT
                                ].includes(val.groupCategory) && "checked"}`}
                              >
                                <Form.Check.Input
                                  type="radio"
                                  name="related-issue"
                                />
                                <Form.Text
                                  className="form-checkbox-label"
                                  onClick={() => {
                                    this.onChange(
                                      [GROUP_KEYS.STATE_DEPARTMENT],
                                      "groupCategory",
                                      idx
                                    );
                                  }}
                                >
                                  {selectedOptionImageUrl ? (
                                    <div className="checkbox-image">
                                      <Image
                                        src={selectedOptionImageUrl}
                                        alt="India Map"
                                      />
                                    </div>
                                  ) : null}
                                  <div className="checkbox-text">
                                    State Department
                                  </div>
                                </Form.Text>
                              </Form.Check>
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <Form.Check
                                className={`form-checkbox ${val.groupCategory ===
                                  GROUP_KEYS.CENTRAL && "checked"}`}
                              >
                                <Form.Check.Input
                                  type="radio"
                                  name="related-issue"
                                />
                                <Form.Text
                                  keyName="groupCategory"
                                  className="form-checkbox-label"
                                  value={val.groupCategory}
                                  onClick={() => {
                                    this.onChange(
                                      [GROUP_KEYS.CENTRAL],
                                      "groupCategory",
                                      idx
                                    );
                                  }}
                                >
                                  <div className="checkbox-image">
                                    <Image
                                      src={IndiaEmblem}
                                      alt="India Emblem"
                                    />
                                  </div>
                                  <div className="checkbox-text">Central</div>
                                </Form.Text>
                              </Form.Check>
                              <Form.Check
                                className={`form-checkbox ${[
                                  GROUP_KEYS.STATE
                                ].includes(val.groupCategory) && "checked"}`}
                              >
                                <Form.Check.Input
                                  type="radio"
                                  name="related-issue"
                                />
                                <Form.Text
                                  className="form-checkbox-label"
                                  onClick={() => {
                                    this.onChange(
                                      [GROUP_KEYS.STATE],
                                      "groupCategory",
                                      idx
                                    );
                                  }}
                                >
                                  <div className="checkbox-image">
                                    <Image src={IndiaMap} alt="India Map" />
                                  </div>
                                  <div className="checkbox-text">State</div>
                                </Form.Text>
                              </Form.Check>
                            </React.Fragment>
                          )}
                        </div>
                        {this.showInputFieldErrorMessage("groupCategory", idx)}
                      </Form.Group>
                    )}

                    {val.groupCategory === GROUP_KEYS.CENTRAL && (
                      <>
                        <Form.Group
                          className={`field-select ${
                            isEdit ? "mb-0" : "margin-b1"
                          }`}
                          as={Col}
                          md="6"
                          controlId="name"
                          onClick={this.handleDisplayDropdown}
                        >
                          <Form.Label>
                            Central Ministry
                            <span className="required">*</span>
                          </Form.Label>
                          <div
                            className="form-field outer-loader-wrapper"
                            onClick={this.handleDisplayDropdown}
                          >
                            <Form.Control
                              as="select"
                              value={val.selectedMinistryId}
                              onChange={e => {
                                this.onChange(
                                  e.target.value,
                                  "recipientGroupId",
                                  idx,
                                  null,
                                  "ministry"
                                );
                              }}
                              disabled={
                                !isValidArray(list) ||
                                isFormTypeNotDefault ||
                                (isEdit &&
                                  get(user, "groupCategory") !== "PMG" &&
                                  get(issueData, "data.issueStatus") !==
                                    "UNDER_VERIFICATION")
                              }
                            >
                              <option value="" selected>
                                - Select{" "}
                                {transformProjectCategoryId(val.groupCategory)}{" "}
                                -
                              </option>
                              {(list || []).map((value, idx) => {
                                return (
                                  <option
                                    value={value.id}
                                    key={`option-key-${idx}`}
                                  >
                                    {value.name}
                                  </option>
                                );
                              })}
                            </Form.Control>
                            {backButtonPress ? null : (
                              <InnerLoader
                                loading={isGroupLoading === STATUS.LOADING}
                                className={"add-issue-loader"}
                              />
                            )}
                          </div>
                          {this.showInputFieldErrorMessage(
                            "selectedMinistryId",
                            idx
                          )}
                        </Form.Group>

                        {isProjectAwardedByState ? null : (
                          <Form.Group
                            className="field-select mb-0"
                            as={Col}
                            md="6"
                            controlId="name"
                            onClick={this.handleDisplayDropdown}
                            //style={{d}}
                          >
                            <div
                              className="form-field outer-loader-wrapper"
                              onClick={this.handleDisplayDropdown}
                            >
                              <SelectStateDropDown
                                className={"field-mscb"}
                                type="select"
                                key="district"
                                value={ministryDistrictAndDepartment}
                                onChange={value => {
                                  this.onChange(
                                    value,
                                    "ministryDistrictAndDepartment",
                                    idx
                                  );
                                }}
                                isDisabled={
                                  !isValidArray(ministryOptions) ||
                                  isFormTypeNotDefault ||
                                  (isEdit &&
                                    get(user, "groupCategory") !== "PMG" &&
                                    get(issueData, "data.issueStatus") !==
                                      "UNDER_VERIFICATION")
                                }
                                label="Central Department"
                                options={ministryOptions}
                                displayError={false}
                              />
                            </div>
                            {this.showInputFieldErrorMessage(
                              "ministryDistrictAndDepartment",
                              idx
                            )}
                          </Form.Group>
                        )}
                      </>
                    )}
                    {isEdit &&
                    this.state.addSecondary &&
                    val.groupCategory === GROUP_KEYS.CENTRAL ? (
                      <div
                        className="addSecondary"
                        onClick={() => this.handleAdd()}
                        style={{
                          marginBottom:
                            isEdit && get(user, "groupCategory") !== "PMG"
                              ? "0"
                              : "1rem",
                          visibility:
                            isEdit && get(user, "groupCategory") !== "PMG"
                              ? "hidden"
                              : "visible"
                        }}
                      >
                        Add Secondary Recipient
                      </div>
                    ) : null}
                    {isEdit &&
                    (this.state.deleteSecondary || val.secondaryStateId) &&
                    val.groupCategory === GROUP_KEYS.CENTRAL ? (
                      <>
                        <Form.Group
                          className="field-select mb-0 mt-3"
                          as={Col}
                          md="6"
                          controlId="name"
                          onClick={this.handleDisplayDropdown}
                        >
                          <Form.Label style={{ color: "#E14A2C" }}>
                            State
                          </Form.Label>
                          <div
                            className="form-field outer-loader-wrapper"
                            onClick={this.handleDisplayDropdown}
                          >
                            <Form.Control
                              as="select"
                              value={val.secondaryStateId || ""}
                              onChange={e => {
                                this.onChange(
                                  e.target.value,
                                  "secondaryStateId",
                                  idx,
                                  null,
                                  "state"
                                );
                              }}
                              disabled={
                                isEdit && get(user, "groupCategory") !== "PMG"
                              }
                            >
                              <option value="" selected>
                                - Select State -
                              </option>
                              {(stateOptions || []).map((value, idx) => {
                                return (
                                  <option
                                    value={value.id}
                                    key={`option-key-${idx}`}
                                  >
                                    {value.name}
                                  </option>
                                );
                              })}
                            </Form.Control>
                            <InnerLoader
                              loading={isGroupLoading === STATUS.LOADING}
                              className={"add-issue-loader"}
                            />
                          </div>
                        </Form.Group>
                        <Form.Group
                          className="field-select mb-0 mt-3"
                          as={Col}
                          md="6"
                          controlId="name"
                          onClick={this.handleDisplayDropdown}
                        >
                          <div
                            className="form-field outer-loader-wrapper"
                            onClick={this.handleDisplayDropdown}
                          >
                            <SelectStateDropDown
                              className={"field-mscb"}
                              type="select"
                              key="district"
                              value={secondaryStateDepartmentId}
                              onChange={value => {
                                this.onChange(
                                  value,
                                  "secondaryStateDepartmentId",
                                  idx
                                );
                              }}
                              isDisabled={
                                isEdit && get(user, "groupCategory") !== "PMG"
                              }
                              label="State District/Department"
                              options={secondarydistrictOptions}
                              displayError={false}
                              classSecondary={"color-secondary"}
                            />
                          </div>
                        </Form.Group>
                      </>
                    ) : null}

                    {isEdit &&
                    this.state.deleteSecondary &&
                    val.groupCategory === GROUP_KEYS.CENTRAL ? (
                      <div
                        className="addSecondary"
                        onClick={() => this.handleDelete()}
                        style={{
                          marginBottom:
                            isEdit && get(user, "groupCategory") !== "PMG"
                              ? "0"
                              : "1rem",
                          visibility:
                            isEdit && get(user, "groupCategory") !== "PMG"
                              ? "hidden"
                              : "visible"
                        }}
                      >
                        Delete Secondary Recipient
                      </div>
                    ) : null}
                    {isProjectAwardedByState ? (
                      <Form.Group
                        className="field-select"
                        as={Col}
                        md="6"
                        controlId="name"
                        onClick={this.handleDisplayDropdown}
                      >
                        <Form.Label>
                          Select {transformProjectCategoryId(val.groupCategory)}
                          <span className="required">*</span>
                        </Form.Label>
                        <div
                          className="form-field outer-loader-wrapper"
                          onClick={this.handleDisplayDropdown}
                        >
                          <Form.Control
                            as="select"
                            value={val.recipientGroupId}
                            onChange={e => {
                              this.onChange(
                                e.target.value,
                                "recipientGroupId",
                                idx
                              );
                            }}
                            disabled={
                              !isValidArray(list) || isFormTypeNotDefault
                            }
                          >
                            <option value="" selected>
                              - Select{" "}
                              {transformProjectCategoryId(val.groupCategory)} -
                            </option>
                            {(list || []).map((value, idx) => {
                              return (
                                <option
                                  value={value.id}
                                  key={`option-key-${idx}`}
                                >
                                  {value.name}
                                </option>
                              );
                            })}
                          </Form.Control>
                          <InnerLoader
                            loading={isGroupLoading === STATUS.LOADING}
                            className={"add-issue-loader"}
                          />
                        </div>
                        {this.showInputFieldErrorMessage(
                          "recipientGroupId",
                          idx
                        )}
                        {isEdit &&
                        this.state.addSecondaryState &&
                        get(user, "groupCategory") == "STATE_PMG" ? (
                          <div
                            className={`addSecondary ${
                              isEdit ? "mb-0" : "margin-b1"
                            }`}
                            onClick={() => this.handleAdd()}
                            style={{
                              marginBottom:
                                isEdit &&
                                get(user, "groupCategory") !== "STATE_PMG"
                                  ? "0"
                                  : "1rem",
                              visibility:
                                isEdit &&
                                get(user, "groupCategory") !== "STATE_PMG"
                                  ? "hidden"
                                  : "visible",
                              paddingLeft: "0px"
                            }}
                          >
                            Add Secondary Recipient
                          </div>
                        ) : null}
                      </Form.Group>
                    ) : (
                      <Form.Group
                        className={`field-select ${
                          isEdit ? "mb-0" : "margin-b1"
                        }`}
                        as={Col}
                        md="6"
                        controlId="name"
                        onClick={this.handleDisplayDropdown}
                      >
                        <Form.Label>
                          {val.groupCategory !== GROUP_KEYS.STATE
                            ? "Issue Location"
                            : "State"}
                          {(isEdit &&
                            val.groupCategory !== GROUP_KEYS.CENTRAL) ||
                          (get(user, "groupCategory") === "PP" && isEdit) ||
                          (get(user, "groupCategory") === "CENTRAL" &&
                            isEdit) ? (
                            <span className="required">*</span>
                          ) : !isEdit ? (
                            <span className="required">*</span>
                          ) : (
                            ""
                          )}
                        </Form.Label>
                        <div
                          className="form-field outer-loader-wrapper"
                          onClick={this.handleDisplayDropdown}
                        >
                          <Form.Control
                            as="select"
                            value={val.selectedStateId || ""}
                            onChange={e => {
                              this.onChange(
                                e.target.value,
                                "recipientGroupId",
                                idx,
                                null,
                                "state"
                              );
                            }}
                            disabled={
                              isEdit &&
                              issueDetails[0].selectedStateId != undefined &&
                              get(user, "groupCategory") !== "PMG" &&
                              get(issueData, "data.issueStatus") !==
                                "UNDER_VERIFICATION"
                            }
                          >
                            <option value="" selected>
                              {val.groupCategory !== GROUP_KEYS.STATE
                                ? "- Select Issue Location -"
                                : "- Select State -"}
                            </option>
                            {(stateOptions || []).map((value, idx) => {
                              return (
                                <option
                                  value={value.id}
                                  key={`option-key-${idx}`}
                                >
                                  {value.name}
                                </option>
                              );
                            })}
                          </Form.Control>
                          <InnerLoader
                            loading={isGroupLoading === STATUS.LOADING}
                            className={"add-issue-loader"}
                          />
                        </div>
                        {this.showInputFieldErrorMessage(
                          "selectedStateId",
                          idx
                        )}
                      </Form.Group>
                    )}
                    {isProjectAwardedByState ? null : (
                      <Form.Group
                        className="field-select"
                        as={Col}
                        md="6"
                        onClick={this.handleDisplayDropdown}
                      >
                        <Form.Label>
                          {val.groupCategory !== GROUP_KEYS.STATE
                            ? "Issue District"
                            : "State District/Department"}
                          {!(
                            isEdit && get(user, "groupCategory") === "PMG"
                          ) && <span className="required">*</span>}
                        </Form.Label>
                        <div
                          className="form-field outer-loader-wrapper"
                          onClick={this.handleDisplayDropdown}
                        >
                          <CustomDropdown
                            options={[
                              {
                                value:
                                  val.groupCategory !== GROUP_KEYS.STATE
                                    ? "- Select Issue District -"
                                    : "- Select State District/Department -",
                                label:
                                  val.groupCategory !== GROUP_KEYS.STATE
                                    ? "- Select Issue District -"
                                    : "- Select State District/Department -",
                                id: ""
                              },
                              ...(
                                (isValidArray(districtOptions) &&
                                  districtOptions) ||
                                []
                              ).map(item => ({
                                value: item.name,
                                label: item.name,
                                id: item.id
                              }))
                            ]}
                            height={"40px"}
                            width={"382px"}
                            className={"create-issue"}
                            page={"issue-district"}
                            menuClassName={"districtMenu"}
                            isEdit={isEdit}
                            value={
                              (
                                (
                                  (isValidArray(districtOptions) &&
                                    districtOptions) ||
                                  []
                                ).find(
                                  i => i.id === stateDistrictAndDepartment
                                ) || {}
                              ).name || null
                            }
                            onChange={this.onChange}
                            idx={idx}
                            loading={isIssueLoading === STATUS.LOADING}
                            resetForm={this.state.resetForm}
                          />
                        </div>
                        {this.showInputFieldErrorMessage(
                          "stateDistrictAndDepartment",
                          idx
                        )}
                      </Form.Group>

                      // <Form.Group
                      //   className={`field-select ${
                      //     val.groupCategory == GROUP_KEYS.STATE ? "mb-0" : ""
                      //   }`}
                      //   as={Col}
                      //   md="6"
                      //   controlId="name"
                      //   onClick={this.handleDisplayDropdown}
                      // >
                      //   <div
                      //     className="form-field outer-loader-wrapper"
                      //     onClick={this.handleDisplayDropdown}
                      //   >
                      //     <Form.Label> {
                      //         val.groupCategory !== GROUP_KEYS.STATE
                      //           ? "Issue District"
                      //           : "State District/Department"
                      //       }</Form.Label>
                      //     <CustomDropdown
                      //     options={[
                      //       {
                      //         value: "- Select Issue Category -",
                      //         label: "- Select Issue Category -",
                      //         id: ""
                      //       },
                      //       ...(
                      //         (isValidArray(districtOptions) &&
                      //           districtOptions) ||
                      //         []
                      //       ).map(item => ({
                      //         value: item.name,
                      //         label: item.name,
                      //         id: item.id
                      //       }))
                      //     ]}
                      //     height={"40px"}
                      //     width={"382px"}
                      //     className={"create-issue"}
                      //     page={"create-issue"}
                      //     menuClassName={"createIssueMenu"}
                      //     isEdit={isEdit}
                      //     value={
                      //       (
                      //         (
                      //           (isValidArray(issuesCategoryList) &&
                      //             issuesCategoryList) ||
                      //           []
                      //         ).find(i => i.id === val.issueCategoryId) || {}
                      //       ).name || null
                      //     }
                      //     onChange={this.onChange}
                      //     idx={idx}
                      //     disabled={isEdit &&
                      //         issueDetails[0].stateDistrictAndDepartment !=
                      //           undefined &&
                      //         get(user, "groupCategory") !== "PMG" &&
                      //         get(issueData, "data.issueStatus") !==
                      //           "UNDER_VERIFICATION"}
                      //   />

                      //     {/* <SelectStateDropDown
                      //       className={"field-mscb"}
                      //       type="select"
                      //       key="district"
                      //       value={stateDistrictAndDepartment}
                      //       onChange={value => {
                      //         this.onChange(
                      //           value,
                      //           "stateDistrictAndDepartment",
                      //           idx
                      //         );
                      //       }}
                      //       isDisabled={
                      //         isEdit &&
                      //         issueDetails[0].stateDistrictAndDepartment !=
                      //           undefined &&
                      //         get(user, "groupCategory") !== "PMG" &&
                      //         get(issueData, "data.issueStatus") !==
                      //           "UNDER_VERIFICATION"
                      //       }
                      //       label={
                      //         val.groupCategory !== GROUP_KEYS.STATE
                      //           ? "Issue District"
                      //           : "State District/Department"
                      //       }
                      //       options={districtOptions}
                      //       displayError={false}
                      //     /> */}

                      //   </div>
                      //   {this.showInputFieldErrorMessage(
                      //     "stateDistrictAndDepartment",
                      //     idx
                      //   )}
                      // </Form.Group>
                    )}
                    {isEdit &&
                    this.state.addSecondaryForState &&
                    val.groupCategory == GROUP_KEYS.STATE ? (
                      <div
                        className="addSecondary"
                        onClick={() => this.handleAddForState()}
                        style={{
                          marginBottom:
                            isEdit && get(user, "groupCategory") !== "PMG"
                              ? "0"
                              : "1rem",
                          marginTop: isEdit ? -10 : null,
                          visibility:
                            isEdit && get(user, "groupCategory") !== "PMG"
                              ? "hidden"
                              : "visible"
                        }}
                      >
                        Add Secondary Recipient
                      </div>
                    ) : null}
                    {this.state.deleteSecondaryForState &&
                    val.groupCategory == GROUP_KEYS.STATE ? (
                      <>
                        <Form.Group
                          className="field-select mb-0 mt-3"
                          as={Col}
                          md="6"
                          controlId="name"
                          onClick={this.handleDisplayDropdown}
                        >
                          <Form.Label style={{ color: "#E14A2C" }}>
                            Central Ministry
                          </Form.Label>
                          <div
                            className="form-field outer-loader-wrapper"
                            onClick={this.handleDisplayDropdown}
                          >
                            <Form.Control
                              as="select"
                              value={val.secondaryMinistryId}
                              onChange={e => {
                                this.onChange(
                                  e.target.value,
                                  "secondaryMinistryId",
                                  idx,
                                  null,
                                  "ministry"
                                );
                              }}
                              disabled={
                                isEdit && get(user, "groupCategory") !== "PMG"
                              }
                            >
                              <option value="" selected>
                                - Select{" "}
                                {transformProjectCategoryId(GROUP_KEYS.CENTRAL)}{" "}
                                -
                              </option>
                              {(listSecondary || []).map((value, idx) => {
                                return (
                                  <option
                                    value={value.id}
                                    key={`option-key-${idx}`}
                                  >
                                    {value.name}
                                  </option>
                                );
                              })}
                            </Form.Control>
                            <InnerLoader
                              loading={isGroupLoading === STATUS.LOADING}
                              className={"add-issue-loader"}
                            />
                          </div>
                        </Form.Group>

                        {isProjectAwardedByState ? null : (
                          <Form.Group
                            className="field-select mb-0 mt-3"
                            as={Col}
                            md="6"
                            controlId="name"
                            onClick={this.handleDisplayDropdown}
                          >
                            <div
                              className="form-field outer-loader-wrapper"
                              onClick={this.handleDisplayDropdown}
                            >
                              <SelectStateDropDown
                                className={"field-mscb"}
                                type="select"
                                key="district"
                                value={val.secondaryMinistryDepartmentId}
                                onChange={value => {
                                  this.onChange(
                                    value,
                                    "secondaryMinistryDepartmentId",
                                    idx
                                  );
                                }}
                                isDisabled={
                                  isEdit && get(user, "groupCategory") !== "PMG"
                                }
                                label="Central Department"
                                options={secondaryDepartmentOptions}
                                displayError={false}
                                classSecondary={"color-secondary"}
                              />
                            </div>
                          </Form.Group>
                        )}
                      </>
                    ) : null}
                    {isEdit &&
                    this.state.deleteSecondaryForState &&
                    val.groupCategory === GROUP_KEYS.STATE ? (
                      <div
                        className="addSecondary"
                        onClick={() => this.handleDeleteForState()}
                        style={{
                          marginBottom:
                            isEdit && get(user, "groupCategory") !== "PMG"
                              ? "0"
                              : "1rem",
                          visibility:
                            isEdit && get(user, "groupCategory") !== "PMG"
                              ? "hidden"
                              : "visible"
                        }}
                      >
                        Delete Secondary Recipient
                      </div>
                    ) : null}
                    {/* secondary recipient state issues */}
                    {isEdit &&
                    isProjectAwardedByState &&
                    this.state.deleteSecondaryState ? (
                      <Form.Group
                        className="field-select"
                        as={Col}
                        md="6"
                        controlId="name"
                        onClick={this.handleDisplayDropdown}
                      >
                        <Form.Label style={{ color: "#E14A2C" }}>
                          Select{" "}
                          {val.groupCategory === GROUP_KEYS.DISTRICT
                            ? "State Department"
                            : "District"}
                        </Form.Label>
                        <div
                          className="form-field outer-loader-wrapper"
                          onClick={this.handleDisplayDropdown}
                        >
                          <Form.Control
                            as="select"
                            value={val.secondaryRecipientGroupId}
                            onChange={e => {
                              this.onChange(
                                e.target.value,
                                "secondaryRecipientGroup",
                                idx
                              );
                            }}
                            disabled={!val.issueSecondaryRecipientEditable}
                          >
                            <option value="" selected>
                              - Select{" "}
                              {transformProjectCategoryId(
                                val.groupCategory === GROUP_KEYS.DISTRICT
                                  ? "State Department"
                                  : "District"
                              )}{" "}
                              -
                            </option>
                            {(secondaryStateDeptDistrict || []).map(
                              (value, idx) => {
                                return (
                                  <option
                                    value={value.id}
                                    key={`option-key-${idx}`}
                                  >
                                    {value.name}
                                  </option>
                                );
                              }
                            )}
                          </Form.Control>
                        </div>
                        <div
                          className={`addSecondary ${
                            isEdit ? "mb-0" : "margin-b1"
                          }`}
                          onClick={() => this.handleDelete()}
                          style={{
                            marginBottom:
                              isEdit &&
                              get(user, "groupCategory") !== "STATE_PMG"
                                ? "0"
                                : "1rem",
                            visibility:
                              isEdit &&
                              get(user, "groupCategory") !== "STATE_PMG"
                                ? "hidden"
                                : "visible",
                            paddingLeft: "0px"
                          }}
                        >
                          Delete Secondary Recipient
                        </div>
                      </Form.Group>
                    ) : null}

                    <Form.Group
                      className="field-select"
                      as={Col}
                      md="6"
                      onClick={this.handleDisplayDropdown}
                    >
                      <Form.Label>
                        Issue Category
                        <span className="required">*</span>
                      </Form.Label>
                      <div
                        className="form-field outer-loader-wrapper"
                        onClick={this.handleDisplayDropdown}
                      >
                        <CustomDropdown
                          options={[
                            {
                              value: "- Select Issue Category -",
                              label: "- Select Issue Category -",
                              id: ""
                            },
                            ...(
                              (isValidArray(issuesCategoryList) &&
                                issuesCategoryList) ||
                              []
                            ).map(item => ({
                              value: item.name,
                              label: item.name,
                              id: item.id
                            }))
                          ]}
                          height={"40px"}
                          width={"382px"}
                          className={"create-issue"}
                          page={"create-issue"}
                          menuClassName={"createIssueMenu"}
                          isEdit={isEdit}
                          value={
                            (
                              (
                                (isValidArray(issuesCategoryList) &&
                                  issuesCategoryList) ||
                                []
                              ).find(i => i.id === val.issueCategoryId) || {}
                            ).name || null
                          }
                          onChange={this.onChange}
                          idx={idx}
                          loading={isIssueLoading === STATUS.LOADING}
                          resetForm={this.state.resetForm}
                        />
                        {/* <Form.Control
                          as="select"
                          value={val.issueCategoryId || ""}
                          onChange={e => {
                            this.onChange(
                              e.target.value,
                              "issueCategoryId",
                              idx
                            );
                          }}
                          disabled={
                            !isValidArray(issuesCategoryList) ||
                            isFormTypeNotDefault
                          }
                        >
                          <option value="" selected>
                            - Select Issue Category -
                          </option>
                          {(
                            (isValidArray(issuesCategoryList) &&
                              issuesCategoryList) ||
                            []
                          ).map((value, index) => {
                            return (
                              <option value={value.id} key={`valueId-${index}`}>
                                {value.name}
                              </option>
                            );
                          })}
                        </Form.Control> */}
                        <InnerLoader
                          loading={isIssueLoading === STATUS.LOADING}
                          className={"add-issue-loader"}
                        />
                      </div>
                      {this.showInputFieldErrorMessage("issueCategoryId", idx)}
                    </Form.Group>

                    {/* {(isEdit ? (
                      val.showSubcategory
                    ) : (
                      !isProjectAwardedByState
                    )) ? (
                      <React.Fragment onClick={this.handleDisplayDropdown}>
                        <Form.Group className="field-select" as={Col} md="6">
                          <Form.Label>
                            Issue Sub Category
                            <span className="required">*</span>
                          </Form.Label>
                          <div
                            className="form-field outer-loader-wrapper"
                            onClick={this.handleDisplayDropdown}
                          >
                            <Form.Control
                              as="select"
                              value={val.issueSubCategoryId || ""}
                              onChange={e => {
                                this.onChange(
                                  e.target.value,
                                  "issueSubCategoryId",
                                  idx
                                );
                              }}
                              disabled={
                                !isValidArray(subCategoryArr) ||
                                isFormTypeNotDefault
                              }
                            >
                              <option value="" selected>
                                - Select Issue Sub Category -
                              </option>
                              {(subCategoryArr || []).map(value => {
                                return (
                                  <option value={value.id}>{value.name}</option>
                                );
                              })}
                            </Form.Control>
                            <InnerLoader
                              loading={isIssueSubLoading === STATUS.LOADING}
                              className={"add-issue-loader"}
                            />
                          </div>
                          {val.issueCategoryId && isValidArray(subCategoryArr)
                            ? this.showInputFieldErrorMessage(
                                "issueSubCategoryId",
                                idx
                              )
                            : ""}
                        </Form.Group>
                      </React.Fragment>
                    ) : (
                      <React.Fragment onClick={this.handleDisplayDropdown}>
                        <Form.Group className="field-select" as={Col} md="6">
                          <Form.Label>
                            Issue Sub Category
                            <span className="required">*</span>
                          </Form.Label>
                          <div
                            className="form-field outer-loader-wrapper"
                            onClick={this.handleDisplayDropdown}
                          >
                            <Form.Control
                              as="select"
                              value={val.issueSubCategoryId || ""}
                              onChange={e => {
                                this.onChange(
                                  e.target.value,
                                  "issueSubCategoryId",
                                  idx
                                );
                              }}
                              disabled={
                                !isValidArray(subCategoryArr) ||
                                isFormTypeNotDefault
                              }
                            >
                              <option value="" selected>
                                - Select Issue Sub Category -
                              </option>
                              {(subCategoryArr || []).map(value => {
                                return (
                                  <option value={value.id}>{value.name}</option>
                                );
                              })}
                            </Form.Control>
                            <InnerLoader
                              loading={isIssueSubLoading === STATUS.LOADING}
                              className={"add-issue-loader"}
                            />
                          </div>
                          {val.issueCategoryId && isValidArray(subCategoryArr)
                            ? this.showInputFieldErrorMessage(
                                "issueSubCategoryId",
                                idx
                              )
                            : ""}
                        </Form.Group>
                      </React.Fragment>
                    )} */}
                    <React.Fragment onClick={this.handleDisplayDropdown}>
                      <Form.Group className="field-select" as={Col} md="6">
                        <Form.Label>
                          Issue Sub Category
                          <span className="required">*</span>
                        </Form.Label>
                        <div
                          className="form-field outer-loader-wrapper"
                          onClick={this.handleDisplayDropdown}
                        >
                          <CustomDropdown
                            options={[
                              {
                                value: "- Select Issue Sub Category -",
                                label: "- Select Issue Sub Category -",
                                id: ""
                              },
                              ...(subCategoryArr || []).map(item => ({
                                value: item.name,
                                label: item.name,
                                id: item.id
                              }))
                            ]}
                            height={"40px"}
                            width={"382px"}
                            className={"issue-subcategory"}
                            page={"issueSubcategory"}
                            menuClassName={"subCategoryMenu"}
                            isEdit={isEdit}
                            value={
                              (
                                (subCategoryArr || []).find(
                                  i => i.id === val.issueSubCategoryId
                                ) || {}
                              ).name || ""
                            }
                            onChange={this.onChange}
                            idx={idx}
                            disabled={
                              !isValidArray(subCategoryArr) ||
                              isFormTypeNotDefault
                            }
                          />
                          {/* <Form.Control
                            as="select"
                            value={val.issueSubCategoryId || ""}
                            onChange={e => {
                              this.onChange(
                                e.target.value,
                                "issueSubCategoryId",
                                idx
                              );
                            }}
                            disabled={
                              !isValidArray(subCategoryArr) ||
                              isFormTypeNotDefault
                            }
                          >
                            <option value="" selected>
                              - Select Issue Sub Category -
                            </option>
                            {(subCategoryArr || []).map(value => {
                              return (
                                <option value={value.id}>{value.name}</option>
                              );
                            })}
                          </Form.Control> */}
                          <InnerLoader
                            loading={isIssueSubLoading === STATUS.LOADING}
                            className={"add-issue-loader"}
                          />
                        </div>
                        {val.issueCategoryId && isValidArray(subCategoryArr)
                          ? this.showInputFieldErrorMessage(
                              "issueSubCategoryId",
                              idx
                            )
                          : ""}
                      </Form.Group>
                    </React.Fragment>

                    {val.issueCategoryId === "11" ||
                    val.issueCategoryId === 11 ? (
                      <Form.Group
                        className="field-select"
                        as={Col}
                        md="6"
                        controlId="name"
                        onClick={this.handleDisplayDropdown}
                      >
                        <div
                          className="form-field outer-loader-wrapper"
                          onClick={this.handleDisplayDropdown}
                        >
                          <SelectStateDropDown
                            className={"field-mscb"}
                            isRequired
                            requiredClass={"required"}
                            type="select"
                            key="forum"
                            value={forum}
                            onChange={value => {
                              this.onChange(value, "forum", idx, forumArr);
                            }}
                            isDisabled={
                              !isValidArray(forumArr) || isFormTypeNotDefault
                            }
                            label="Forum"
                            options={forumArr}
                            displayError={false}
                          />
                        </div>
                        {this.showInputFieldErrorMessage("forum", idx)}
                      </Form.Group>
                    ) : null}

                    {val.issueCategoryId === "11" ||
                    val.issueCategoryId === 11 ? (
                      <Form.Group
                        onClick={this.handleDisplayDropdown}
                        className="field-datepicker form-group col-md-6"
                      >
                        <Form.Label>Date of Order</Form.Label>
                        <div className="form-field">
                          <DatePicker
                            onChange={value =>
                              this.onChange(value, "dateOfOrder", idx)
                            }
                            selected={dateOfOrder}
                            value={dateOfOrder}
                            minDate={dateOfOrder}
                            isClearable={dateOfOrder}
                          />
                        </div>
                        {this.showInputFieldErrorMessage("dateOfOrder", idx)}
                      </Form.Group>
                    ) : null}

                    {proposalNoPariveshCondition ? (
                      <React.Fragment onClick={this.handleDisplayDropdown}>
                        <Form.Group className="field-select" as={Col} md="6">
                          <Form.Label>
                            Proposal No. (PARIVESH)
                            {(get(user, "groupCategory") === "PP" &&
                              isEdit &&
                              !isProjectAwardedByState) ||
                            (get(user, "groupCategory") === "CENTRAL" &&
                              isEdit &&
                              !isProjectAwardedByState) ||
                            (!isEdit && !isProjectAwardedByState) ? (
                              <span className="required">*</span>
                            ) : (
                              ""
                            )}
                          </Form.Label>
                          <div
                            className="form-field outer-loader-wrapper"
                            onClick={this.handleDisplayDropdown}
                          >
                            <InputGroup
                              className="validate-input-group"
                              style={{ height: isEdit ? "40px" : "" }}
                            >
                              <Form.Control
                                type="text"
                                id="proposalNoParivesh"
                                className="validate-input-form"
                                style={{ background: "#fff", height: "38px" }}
                                placeholder="Enter Proposal No. (PARIVESH)"
                                onInput={event => {
                                  this.inputLanguage(event, idx);
                                }}
                                value={val.proposalNoParivesh}
                                onChange={e => {
                                  this.onChange(
                                    e.target.value,
                                    "proposalNoParivesh",
                                    idx
                                  );
                                }}
                                onBlur={e => {
                                  this.setState(prev => ({
                                    touchedFields: {
                                      ...prev.touchedFields,
                                      [`proposalNoParivesh-${idx}`]: true
                                    }
                                  }));

                                  const value = e.target.value;
                                  const group = get(user, "groupCategory");
                                  if (isEdit && group === "PMG") return;
                                  if (isEdit && group === "PP") {
                                    this.checkForValidationProposal(value);
                                    return;
                                  }
                                  if (!isEdit && !isProjectAwardedByState) {
                                    this.checkForValidationProposal(value);
                                    return;
                                  }
                                }}
                                isInvalid={
                                  !Boolean(this.state.proposalErrorMessage)
                                }
                              />
                              {!isProjectAwardedByState && (
                                <InputGroup.Append>
                                  <Button
                                    className="button-validate-input"
                                    onMouseDown={e => e.preventDefault()}
                                    style={{
                                      padding: isEdit
                                        ? "0px"
                                        : "6px 15px 6px 1px",
                                      margin: isEdit ? "6px 15px" : "",
                                      visibility: val.proposalNoParivesh
                                        ? "visible"
                                        : "hidden",
                                      background: "#fff",
                                      color: "#4F8EB3",
                                      textDecoration: "underline"
                                    }}
                                    onClick={() =>
                                      this.handleProposalValidation(
                                        val.issueSubCategoryId,
                                        val.proposalNoParivesh,
                                        idx
                                      )
                                    }
                                  >
                                    Validate
                                  </Button>
                                </InputGroup.Append>
                              )}
                            </InputGroup>
                          </div>
                          {indexOfInputField === idx &&
                            this.showingErroMessage(
                              this.state.key === "proposalNoParivesh",
                              indexOfInputField
                            )}
                          {showLanguageError === false &&
                          (val.proposalNoParivesh === "" ||
                            val.proposalNoParivesh === undefined ||
                            val.proposalNoParivesh === null) ? (
                            this.showInputFieldErrorMessage(
                              "proposalNoParivesh",
                              idx
                            )
                          ) : (
                            <div
                              className="escalation-level-errormsg"
                              style={{ padding: "0px 5px" }}
                            >
                              {this.state.proposalErrorMessage}
                            </div>
                          )}
                        </Form.Group>
                      </React.Fragment>
                    ) : null}

                    <Form.Group
                      onClick={this.handleDisplayDropdown}
                      className="field-select"
                      as={Col}
                      md="6"
                    >
                      <Form.Label>Project Stage</Form.Label>
                      <div
                        className="form-field outer-loader-wrapper"
                        onClick={this.handleDisplayDropdown}
                      >
                        <CustomDropdown
                          options={[
                            {
                              value: "- Select Project Stage -",
                              label: "- Select Project Stage -",
                              id: ""
                            },
                            ...((isValidArray(bucketList) && bucketList) || [])
                              .filter(item => item.name !== "Cabinet Milestone")
                              .map(item => ({
                                value: item.name,
                                label: item.name,
                                id: item.id
                              }))
                          ]}
                          height={"40px"}
                          width={"382px"}
                          className={"project-stage"}
                          page={"projectStage"}
                          menuClassName={"projectStageMenu"}
                          isEdit={isEdit}
                          value={
                            (
                              ((isValidArray(bucketList) && bucketList) || [])
                                .filter(
                                  item => item.name !== "Cabinet Milestone"
                                )
                                .find(i => i.id === val.bucketId) || {}
                            ).name || ""
                          }
                          onChange={this.onChange}
                          idx={idx}
                          disabled={!isValidArray(bucketList)}
                          resetForm={this.state.resetForm}
                        />
                        {/* <Form.Control
                          as="select"
                          value={val.bucketId || ""}
                          onChange={e => {
                            this.onChange(e.target.value, "bucketId", idx);
                          }}
                          disabled={!isValidArray(bucketList)}
                        >
                          <option value="" selected>
                            - Select Project Stage -
                          </option>
                          {((isValidArray(bucketList) && bucketList) || []).map(
                            (value, index) => {
                              return (
                                <option
                                  value={value.id}
                                  key={`valueId-${index}`}
                                >
                                  {value.name}
                                </option>
                              );
                            }
                          )}
                        </Form.Control> */}
                        <InnerLoader
                          loading={bucketListStatus === STATUS.LOADING}
                          className={"add-issue-loader"}
                        />
                      </div>
                      {this.showInputFieldErrorMessage("bucketId", idx)}
                    </Form.Group>

                    <React.Fragment>
                      <Form.Group
                        className="field-select"
                        as={Col}
                        md="6"
                        onClick={this.handleDisplayDropdown}
                      >
                        <Form.Label>
                          Phase
                          {(isEdit && val.issueCategoryId === "11") ||
                          issueCOList[idx]["bucketId"] ? (
                            <span className="required">*</span>
                          ) : (
                            ""
                          )}
                        </Form.Label>
                        <div
                          className="form-field outer-loader-wrapper"
                          onClick={this.handleDisplayDropdown}
                        >
                          <CustomDropdown
                            options={[
                              {
                                value: "-Select Phase -",
                                label: "-Select Phase -",
                                id: ""
                              },
                              ...(milesTableListArr || []).map(item => ({
                                value: item.table.name,
                                label: item.table.name,
                                id: item.table.id
                              }))
                            ]}
                            height={"40px"}
                            width={"382px"}
                            className={"select-phase"}
                            page={"selectPhase"}
                            menuClassName={"selectPhaseMenu"}
                            isEdit={isEdit}
                            value={
                              (
                                (milesTableListArr || []).find(
                                  i =>
                                    i.table &&
                                    i.table.id === val.milestoneTableId
                                ) || { table: {} }
                              ).table.name || ""
                            }
                            onChange={this.onChange}
                            idx={idx}
                            disabled={
                              !isValidArray(milesTableListArr) || !val.bucketId
                            }
                            bucketId={val.bucketId}
                          />
                          {/* {console.log(milesTableListArr,val.milestoneTableId)}  */}
                          {/* <Form.Control
                            as="select"
                            value={val.milestoneTableId || ""}
                            onChange={e => {
                              this.onChange(
                                e.target.value,
                                "milestoneTableId",
                                idx,
                                val.bucketId
                              );
                            }}
                            disabled={
                              !isValidArray(milesTableListArr) || !val.bucketId
                            }
                          >
                            <option value="" selected>
                              -Select Phase -
                            </option>
                            {(milesTableListArr || []).map(_val => {
                              let value = _val.table;
                              return (
                                <option value={value.id}>
                                  {value.name} {_val.phaseName ? " - " : ""}{" "}
                                  {_val.phaseName}
                                </option>
                              );
                            })}
                          </Form.Control> */}
                          <InnerLoader
                            loading={milestoneTableStatus === STATUS.LOADING}
                            className={"add-issue-loader"}
                          />
                        </div>

                        {val.bucketId
                          ? this.showInputFieldErrorMessage(
                              "milestoneTableId",
                              idx
                            )
                          : ""}
                      </Form.Group>
                    </React.Fragment>

                    <React.Fragment>
                      <Form.Group
                        className="field-select"
                        as={Col}
                        md="6"
                        onClick={this.handleDisplayDropdown}
                      >
                        <Form.Label>
                          Milestone/Activity
                          {issueCOList[idx]["milestoneTableId"] ? (
                            <span className="required">*</span>
                          ) : (
                            ""
                          )}
                        </Form.Label>
                        <div
                          className="form-field outer-loader-wrapper"
                          onClick={this.handleDisplayDropdown}
                        >
                          <CustomDropdown
                            options={[
                              {
                                value: "- Select Milestone/Activity -",
                                label: "- Select Milestone/Activity -",
                                id: ""
                              },
                              ...(milestoneListsArr || []).map(item => ({
                                value: item.name,
                                label: item.name,
                                id: item.id
                              }))
                            ]}
                            height={"40px"}
                            width={"382px"}
                            className={"select-phase"}
                            page={"milestone-activity"}
                            menuClassName={"milestoneActivity"}
                            isEdit={isEdit}
                            value={
                              (
                                milestoneListsArr.find(
                                  i => i.id === val.milestoneId
                                ) || {}
                              ).name || ""
                            }
                            onChange={this.onChange}
                            idx={idx}
                            disabled={
                              !isValidArray(milestoneListsArr) ||
                              !val.milestoneTableId
                            }
                          />

                          {/* <Form.Control
                            as="select"
                            value={val.milestoneId || ""}
                            onChange={e => {
                              this.onChange(e.target.value, "milestoneId", idx);
                            }}
                            disabled={
                              !isValidArray(milestoneListsArr) ||
                              !val.milestoneTableId
                            }
                          >
                            <option value="" selected>
                              - Select Milestone/Activity -
                            </option>
                            {(milestoneListsArr || []).map(_val => {
                              return (
                                <option value={_val.id}>{_val.name}</option>
                              );
                            })}
                          </Form.Control> */}
                          <InnerLoader
                            loading={milestoneDataListStatus === STATUS.LOADING}
                            className={"add-issue-loader"}
                          />
                        </div>
                        {val.milestoneTableId
                          ? this.showInputFieldErrorMessage("milestoneId", idx)
                          : ""}
                      </Form.Group>
                    </React.Fragment>

                    <React.Fragment>
                      <Form.Group
                        className="field-select"
                        as={Col}
                        md="6"
                        onClick={this.handleDisplayDropdown}
                      >
                        <Form.Label>
                          Responsible Authority
                          {(get(user, "groupCategory") === "PP" && isEdit) ||
                          (get(user, "groupCategory") === "DISTRICT" &&
                            isEdit) ||
                          (get(user, "groupCategory") === "CENTRAL" &&
                            isEdit) ||
                          !isEdit ? (
                            <span className="required">*</span>
                          ) : (
                            ""
                          )}
                        </Form.Label>
                        <div
                          className="form-field outer-loader-wrapper"
                          onClick={this.handleDisplayDropdown}
                        >
                          <Form.Control
                            className={`${this.state.key ===
                              "responsibleAuthority" &&
                              this.state.indexOfInputField === idx &&
                              (languageError === true ||
                                onPasteError === true) &&
                              showLanguageError === true &&
                              "language-error-border-alert"}`}
                            type="text"
                            id="responsibleAuthority"
                            placeholder="Enter Responsible Authority"
                            onInput={event => {
                              this.inputLanguage(event, idx);
                            }}
                            value={
                              this.state.key === "responsibleAuthority" &&
                              this.state.indexOfInputField === idx
                                ? (val.responsibleAuthority = pastedText)
                                : val.responsibleAuthority || ""
                            }
                            onChange={e => {
                              this.onChange(
                                e.target.value,
                                "responsibleAuthority",
                                idx
                              );
                            }}
                          />
                        </div>
                        {this.state.indexOfInputField === idx &&
                          this.showingErroMessage(
                            this.state.key === "responsibleAuthority",
                            indexOfInputField
                          )}
                        {this.props.showLanguageError === false &&
                          (val.responsibleAuthority === "" ||
                            val.responsibleAuthority === undefined) &&
                          this.showInputFieldErrorMessage(
                            "responsibleAuthority",
                            idx
                          )}
                      </Form.Group>
                    </React.Fragment>
                    {(isStateDepartment && showCreatedBy) ||
                    (isStatePMG && showCreatedBy) ? (
                      <Form.Group
                        className="field-select"
                        as={Col}
                        md="6"
                        onClick={this.handleDisplayDropdown}
                        style={{
                          marginTop: this.getProponentmarginTop(
                            proposalNoPariveshCondition,
                            reasonboxDisplay,
                            escalationErrormessage
                          )
                        }}
                      >
                        <Form.Label>
                          Proponent
                          <span className="required">*</span>
                        </Form.Label>
                        <AutoSuggestSelect
                          childIssue={childIssue}
                          isLoading={autoSuggestApiLoading}
                          defaultSelected={defaultSelected || ""}
                          name="projectAutoSuggest"
                          options={projectPPList ? projectPPList : options}
                          disabled={
                            (openedFromCreateProject &&
                              !isProjectAwardedByState) ||
                            isFormTypeNotDefault ||
                            childIssue
                          }
                          onChange={value => {
                            this.onAutoSuggestChangeState(value, idx);
                          }}
                          onOptionClick={value => {
                            this.onOptionClickForState(value, idx);
                          }}
                          StateDepartmentissuePage={isStateDepartment}
                          StatePMGissuePage={isStatePMG}
                          redBorder={true}
                          onBlur={this.proponentBlur}
                        />
                        {this.showInputFieldErrorMessage("userID", idx)}
                      </Form.Group>
                    ) : null}

                    {(get(user, "groupCategory") === "PMG" ||
                      childIssue === true) && (
                      <>
                        <DisplayByPermission display={showCreatedBy}>
                          <Form.Group
                            className="field-select"
                            as={Col}
                            md="6"
                            style={{
                              display:
                                isEdit &&
                                get(
                                  issueData,
                                  "data.projectIssueDTO.sponsoredByCategory"
                                ) == "CENTRAL" &&
                                get(issueData, "data.isCentralPMG") &&
                                !get(issueData, "data.childIssue")
                                  ? null
                                  : "none"
                            }}
                          >
                            <Form.Label onClick={this.handleDisplayDropdown}>
                              Escalation Level
                            </Form.Label>
                            <div
                              class="dropdown"
                              style={{
                                display:
                                  get(issueData, "data.issueStatusName") ==
                                  "Pending with RM/RS"
                                    ? null
                                    : "none"
                              }}
                            >
                              <div
                                class="show dropdown escalation-show-dropdown"
                                style={{
                                  borderRadius: reasonboxDisplay
                                    ? "4px 4px 0px 0px"
                                    : "4px"
                                }}
                              >
                                <button
                                  aria-haspopup="true"
                                  aria-expanded="true"
                                  onClick={
                                    escalationdropdowndisplay
                                      ? this.handleDisplayDropdown
                                      : this.handleDisplay
                                  }
                                  id="dropdown-basic"
                                  type="button"
                                  class="dropdown-toggle btn btn-primary"
                                >
                                  <span className="escalation-level-text">
                                    {val.escalationLevelName == null
                                      ? selectedValue
                                      : val.escalationLevelName}
                                  </span>
                                  <span>
                                    <Image
                                      src={DropdownArrow}
                                      style={{
                                        marginLeft: this.getMarginLeft(
                                          val.escalationLevelName == null
                                            ? selectedValue
                                            : val.escalationLevelName
                                        )
                                      }}
                                      className="escalation-arrow-icon"
                                    />
                                  </span>
                                </button>
                                <div
                                  x-placement="bottom-start"
                                  aria-labelledby="dropdown-basic"
                                  class="dropdown-menu show escalation-dropdown-options"
                                  style={{
                                    position: "absolute",
                                    inset: "0px auto auto 0px",
                                    margin: "0px",
                                    transform: "translate3d(20px, 42px, 0px)",
                                    display: escalationdropdowndisplay
                                      ? null
                                      : "none"
                                  }}
                                >
                                  {(Escalationarr || []).map(_val => {
                                    return (
                                      <span
                                        class="dropdown-item dropdown-option-name"
                                        onClick={() =>
                                          this.onChange(
                                            _val.id,
                                            "escalationLevel",
                                            idx,
                                            _val.name
                                          )
                                        }
                                        value={_val.id}
                                      >
                                        {" "}
                                        <Image src={_val.flag} />
                                        &nbsp;&nbsp;{_val.name}
                                      </span>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>

                            <OverlayTrigger
                              // trigger="hover"
                              trigger={
                                get(issueData, "data.issueStatusName") ==
                                  "Pending with SM" ||
                                get(issueData, "data.issueStatusName") ==
                                  "Pending with PMG"
                                  ? []
                                  : ["hover"]
                              }
                              defaultShow={false}
                              overlay={
                                <Tooltip
                                  style={{
                                    display:
                                      get(issueData, "data.issueStatusName") !=
                                      "Pending with RM/RS"
                                        ? null
                                        : "none"
                                  }}
                                  id={`tooltip-checking`}
                                  className={
                                    get(issueData, "data.issueStatusName") ==
                                      "Under PMG Decision" ||
                                    get(issueData, "data.issueStatusName") ==
                                      "Resolved"
                                      ? "escalation-level-dropdown-tolltip-resolved-underpmg"
                                      : "escalation-level-dropdown-tolltip"
                                  }
                                >
                                  {get(issueData, "data.issueStatusName") ==
                                    "Under PMG Decision" ||
                                  get(issueData, "data.issueStatusName") ==
                                    "Resolved"
                                    ? "Re-open "
                                    : "Verify "}
                                  issue before assigning
                                </Tooltip>
                              }
                            >
                              <Form.Control
                                as="select"
                                className={
                                  escalationdropdowndisplay
                                    ? "escalation-level-select"
                                    : null
                                }
                                // value={val.milestoneId || ""}
                                value={val.escalationLevel || ""}
                                onChange={e => {
                                  this.onChange(
                                    e.target.value,
                                    "milestoneId",
                                    idx
                                  );
                                }}
                                style={{
                                  display:
                                    get(issueData, "data.issueStatusName") ==
                                    "Pending with RM/RS"
                                      ? "none"
                                      : null
                                }}
                                disabled={
                                  get(issueData, "data.issueStatusName") !=
                                  "Pending with RM/RS"
                                }
                              >
                                <option value="escalation_level" selected>
                                  - Select Escalation Level -
                                </option>
                                {(Escalationarr || []).map(_val => {
                                  return (
                                    <option
                                      value={_val.id} //src={_val.flag}
                                      style={{
                                        backgroundImage: `url(${_val.flag})`,
                                        backgroundRepeat: "no-repeat"
                                      }}
                                    >
                                      {_val.name}
                                    </option>
                                  );
                                })}
                              </Form.Control>
                            </OverlayTrigger>

                            <Form.Control
                              style={{
                                display: reasonboxDisplay
                                  ? //selectedValue == "- Select Escalation Level -"
                                    null
                                  : "none",
                                border: bordercolorBox
                                  ? "1.5px solid #FC192E"
                                  : "1px solid #dac885"
                              }}
                              as="textarea"
                              rows="3"
                              value={escalationReason}
                              className="escalation-level-reason-box"
                              placeholder="Reason for Escalation Level change*"
                              onChange={e => {
                                this.onChange(
                                  e.target.value,
                                  "reasonForEscalation",
                                  idx
                                );
                              }}
                            />

                            <div
                              class="escalation-level-errormsg"
                              style={{
                                display: escalationErrormessage ? null : "none"
                              }}
                            >
                              This field is required.
                            </div>
                          </Form.Group>
                          <Form.Group
                            className="field-select"
                            as={Col}
                            md="6"
                            onClick={this.handleDisplayDropdown}
                            style={{
                              marginTop: this.getProponentmarginTop(
                                proposalNoPariveshCondition,
                                reasonboxDisplay,
                                escalationErrormessage
                              )
                            }}
                          >
                            <Form.Label>
                              Proponent
                              {!isProjectAwardedByState || !isEdit ? (
                                <span className="required">*</span>
                              ) : (
                                ""
                              )}
                            </Form.Label>
                            <AutoSuggestSelect
                              childIssue={childIssue}
                              isLoading={autoSuggestApiLoading}
                              defaultSelected={defaultSelected || ""}
                              name="projectAutoSuggest"
                              options={projectPPList ? projectPPList : options}
                              disabled={
                                (openedFromCreateProject &&
                                  !isProjectAwardedByState) ||
                                isFormTypeNotDefault ||
                                childIssue
                              }
                              onChange={value => {
                                this.onAutoSuggestChange(value, idx);
                              }}
                              onOptionClick={value => {
                                this.onOptionClick(value, idx);
                              }}
                              redBorder={true}
                              onBlur={this.proponentBlur}
                            />
                            {this.showInputFieldErrorMessage("userID", idx)}
                            <div
                              class="escalation-level-errormsg"
                              style={{
                                display: proponentErrormsg ? null : "none"
                              }}
                            >
                              This field is required.
                            </div>
                          </Form.Group>
                        </DisplayByPermission>
                      </>
                    )}

                    {/* {isEdit &&
                      get(user, "groupCategory") === "PMG" &&
                      val.groupCategory === "CENTRAL" && (
                        <>
                          <DisplayByPermission display={showCreatedBy}>
                            <Form.Group
                              className="field-select"
                              as={Col}
                              md="6"
                            >
                              <Form.Label>Secondary Recipient</Form.Label>
                              <div className="form-field outer-loader-wrapper">
                                <Form.Control
                                  as="select"
                                  value={val.secondaryRecipient || ""}
                                  onChange={e => {
                                    this.onChange(
                                      e.target.value,
                                      "secondaryRecipient",
                                      idx,
                                      null,
                                      "ministry"
                                    );
                                  }}
                                >
                                  <option value="" selected>
                                    - Select State -
                                  </option>
                                  {(stateOptions || []).map((value, idx) => {
                                    return (
                                      <option
                                        value={value.id}
                                        key={`option-key-${idx}`}
                                      >
                                        {value.name}
                                      </option>
                                    );
                                  })}
                                </Form.Control>
                                <InnerLoader
                                  loading={isGroupLoading === STATUS.LOADING}
                                  className={"add-issue-loader"}
                                />
                              </div>
                            </Form.Group>
                          </DisplayByPermission>
                        </>
                      )} */}

                    {/* {isEdit &&
                      get(user, "groupCategory") === "PMG" &&
                      val.groupCategory === "STATE" && (
                        <>
                          <DisplayByPermission display={showCreatedBy}>
                            <Form.Group
                              className="field-select"
                              as={Col}
                              md="6"
                            >
                              <Form.Label>Secondary Recipient</Form.Label>
                              <div className="form-field outer-loader-wrapper">
                                <Form.Control
                                  as="select"
                                  value={val.secondaryRecipient}
                                  onChange={e => {
                                    this.onChange(
                                      e.target.value,
                                      "secondaryRecipient",
                                      idx,
                                      null,
                                      "state"
                                    );
                                  }}
                                >
                                  <option value="" selected>
                                    - Select -
                                  </option>
                                  {(listSecondary || []).map((value, idx) => {
                                    return (
                                      <option
                                        value={value.id}
                                        key={`option-key-${idx}`}
                                      >
                                        {value.name}
                                      </option>
                                    );
                                  })}
                                </Form.Control>
                                <InnerLoader
                                  loading={isGroupLoading === STATUS.LOADING}
                                  className={"add-issue-loader"}
                                />
                              </div>
                            </Form.Group>
                          </DisplayByPermission>
                        </>
                      )} */}

                    <Form.Group
                      as={Col}
                      md="12"
                      controlId="titleIssue"
                      className="field-select"
                      onClick={this.handleDisplayDropdown}
                    >
                      <Form.Label>
                        Issue Title
                        <span className="required">*</span>
                      </Form.Label>
                      <TooltipComponent
                        classes="add_issue_tooltip"
                        smallIconInfo={InfoIcon}
                        placement="right"
                        content={
                          <>
                            Indicate values in pending/total (km, Ha, units,
                            etc), <br /> district name, alignment affected etc.
                          </>
                        }
                      />
                      {get(user, "groupCategory") == "STATE_PMG" ? (
                        <Form.Control
                          className={`${this.state.key === "title" &&
                            (languageError === true || onPasteError === true) &&
                            showLanguageError === true &&
                            this.state.indexOfInputField === idx &&
                            "language-error-border-alert"}`}
                          type="text"
                          id="title"
                          placeholder="Indicate values in pending/total (km, Ha, units, etc), district name, alignment affected etc."
                          onInput={event => {
                            this.inputLanguage(event, idx);
                          }}
                          value={
                            this.state.key === "title" &&
                            this.state.indexOfInputField === idx
                              ? (val.title = pastedText)
                              : val.title || ""
                          }
                          onChange={e => {
                            this.onChange(e.target.value, "title", idx);
                          }}
                        />
                      ) : (
                        <Form.Control
                          className={`${this.state.key === "title" &&
                            (languageError === true || onPasteError === true) &&
                            showLanguageError === true &&
                            this.state.indexOfInputField === idx &&
                            "language-error-border-alert"}`}
                          type="text"
                          id="title"
                          placeholder="Indicate values in pending/total (km, Ha, units, etc), district name, alignment affected etc."
                          onInput={event => {
                            this.inputLanguage(event, idx);
                          }}
                          value={
                            this.state.key === "title" &&
                            this.state.indexOfInputField === idx
                              ? (val.title = pastedText)
                              : val.title || ""
                          }
                          disabled={
                            isFormTypeNotDefault ||
                            (isEdit &&
                              get(user, "groupCategory") !== "PMG" &&
                              get(issueData, "data.issueStatus") !==
                                "UNDER_VERIFICATION")
                          }
                          onChange={e => {
                            this.onChange(e.target.value, "title", idx);
                          }}
                        />
                      )}
                      {this.state.indexOfInputField === idx &&
                        this.showingErroMessage(
                          this.state.key === "title",
                          indexOfInputField
                        )}
                      {this.props.showLanguageError === false &&
                        (val.title === "" || val.title === undefined) &&
                        this.showInputFieldErrorMessage("title", idx)}
                    </Form.Group>

                    <Form.Group
                      as={Col}
                      md="12"
                      controlId="descIssue"
                      className="field-issue-desc"
                      onClick={this.handleDisplayDropdown}
                    >
                      <Form.Label>
                        Issue Description
                        <span className="required">*</span>
                      </Form.Label>
                      <TooltipComponent
                        classes={
                          isEdit === true
                            ? "edit_issue_comment-tooltip"
                            : "add_issue_tooltip issue_comment_tooltip"
                        }
                        smallIconInfo={InfoIcon}
                        placement="right"
                        content={
                          <>
                            Background on issue, issue pending since (in
                            dd/mm/yyyy, as applicable), impact on project
                            completion, indicate values in pending/total (km,
                            Ha, units, etc), efforts undertaken to resolve issue
                            by User Agency and Sponsoring Ministry (including at
                            the level of head of User Agency and Sponsoring
                            Ministry), use attachment option to upload
                            supporting documents.
                          </>
                        }
                      />
                      <div
                        className={`field-issue-desc-inner ${this.state.key ===
                          "issueDescription" &&
                          this.state.indexOfInputField === idx &&
                          (languageError === true || onPasteError === true) &&
                          showLanguageError === true &&
                          "language-error-border-alert"}`}
                      >
                        {get(user, "groupCategory") == "STATE_PMG" ? (
                          // <Form.Control
                          //   as="textarea"
                          //   rows="5"
                          //   id="issueDescription"
                          //   placeholder="Background on issue, issue pending since (in dd/mm/yyyy, as applicable), impact on project completion, indicate values in pending/total (km, Ha, units, etc), efforts undertaken to resolve issue by User Agency and Sponsoring Ministry (including at the level of head of User Agency and Sponsoring Ministry), use attachment option to upload supporting documents."
                          //   onInput={(event) => {
                          //     this.inputLanguage(event, idx);
                          //   }}
                          //   value={
                          //     this.state.key === "issueDescription" &&
                          //     this.state.indexOfInputField === idx
                          //       ? (val.issueDescription = pastedText)
                          //       : val.issueDescription || ""
                          //   }
                          //   onChange={(e) => {
                          //     this.onChange(
                          //       e.target.value,
                          //       "issueDescription",
                          //       idx
                          //     );
                          //   }}
                          // />
                          <ReactQuill
                            // value={
                            //   this.state.key === 'issueDescription' &&
                            //   this.state.indexOfInputField === idx
                            //     ? (val.issueDescription = pastedText)
                            //     : val.issueDescription || ''
                            // }
                            value={
                              this.state.issueCOList[idx].issueDescription || ""
                            }
                            id="issueDescription"
                            onChange={(html, delta, source, editor) => {
                              this.handleChange(
                                html,
                                delta,
                                source,
                                editor,
                                "issueDescription",
                                idx
                              );
                            }}
                            theme="snow"
                            modules={toolbarConfig}
                            formats={formats}
                            bounds={".app"}
                            placeholder={`Background on issue, issue pending since (in dd/mm/yyyy, as applicable), impact on project completion, indicate values in pending/total (km, Ha, units, etc), efforts undertaken to resolve issue by User Agency and Sponsoring Ministry (including at the level of head of User Agency and Sponsoring Ministry), use attachment option to upload supporting documents.`}
                            ref={el => {
                              this.reactQuillRef = el;
                            }}
                          />
                        ) : (
                          <>
                            {/* <Form.Control
                              as="textarea"
                              rows="5"
                              id="issueDescription"
                              placeholder="Background on issue, issue pending since (in dd/mm/yyyy, as applicable), impact on project completion, indicate values in pending/total (km, Ha, units, etc), efforts undertaken to resolve issue by User Agency and Sponsoring Ministry (including at the level of head of User Agency and Sponsoring Ministry), use attachment option to upload supporting documents."
                              onInput={(event) => {
                                this.inputLanguage(event, idx);
                              }}
                              value={
                                this.state.key === "issueDescription" &&
                                this.state.indexOfInputField === idx
                                  ? (val.issueDescription = pastedText)
                                  : val.issueDescription || ""
                              }
                              disabled={
                                isFormTypeNotDefault ||
                                (isEdit &&
                                  get(user, "groupCategory") !== "PMG" &&
                                  get(issueData, "data.issueStatus") !==
                                    "UNDER_VERIFICATION")
                              }
                              onChange={(e) => {
                                this.onChange(
                                  e.target.value,
                                  "issueDescription",
                                  idx
                                );
                              }}
                            /> */}
                            <ReactQuill
                              // value={
                              //   this.state.key === 'issueDescription' &&
                              //   this.state.indexOfInputField === idx
                              //     ? (val.issueDescription = pastedText)
                              //     : val.issueDescription || ''
                              // }
                              value={
                                this.state.issueCOList[idx].issueDescription ||
                                ""
                              }
                              id="issueDescription"
                              onChange={(html, delta, source, editor) => {
                                this.handleChange(
                                  html,
                                  delta,
                                  source,
                                  editor,
                                  "issueDescription",
                                  idx
                                );
                              }}
                              // onChange={(value, delta, source, editor) => {
                              //   this.onChange(value, "issueDescription", idx);
                              // }}
                              theme="snow"
                              modules={toolbarConfig}
                              formats={formats}
                              bounds={".app"}
                              placeholder={`Background on issue, issue pending since (in dd/mm/yyyy, as applicable), impact on project completion, indicate values in pending/total (km, Ha, units, etc), efforts undertaken to resolve issue by User Agency and Sponsoring Ministry (including at the level of head of User Agency and Sponsoring Ministry), use attachment option to upload supporting documents.`}
                              ref={el => {
                                this.reactQuillRef = el;
                              }}
                              disabled={
                                isFormTypeNotDefault ||
                                (isEdit &&
                                  get(user, "groupCategory") !== "PMG" &&
                                  get(issueData, "data.issueStatus") !==
                                    "UNDER_VERIFICATION")
                              }
                            />
                          </>
                        )}
                      </div>
                      {val.files !== null &&
                      val.files !== undefined &&
                      val.files.length !== 0 ? (
                        <hr
                          className="hr-css"
                          //style={{ marginTop: "0px", marginBottom: "0px", paddingLeft: "20px", width:"774px", height:"1px"}}
                        />
                      ) : null}
                      <Form.Group className="field-attachment-issue">
                        {/* <section className="display-attachments-section-forward attachments"> */}
                        <div className="uploaded-file-wrapper">
                          {get(val, "files", []).map((file, index) => (
                            <div className="uploaded-file-issue">
                              <div
                                className="remove-file-issue"
                                onClick={() => {
                                  this.onRemoveFile(file, "files", idx, index);
                                }}
                              />
                              <div className="file-detail-issue">
                                {VIDEO_FORMATS.includes(extension) ? (
                                  <>
                                    <div className="video-upload-icon" />
                                    <div
                                      className="video-player pl-1"
                                      onClick={() => {
                                        this.setState({
                                          showVideoPlayer: true,
                                          videoUrl: file.s3Url,
                                          videoTitle: file.title || file.name
                                        });
                                      }}
                                    >
                                      {file.title || file.name}
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className="upload-icon">
                                      {extension}
                                    </div>
                                    <a
                                      target="_blank"
                                      href={file.s3Url}
                                      className="no-underline"
                                      //style={{ textDecorationLine: "none" }}
                                    >
                                      {file.title
                                        ? file.title.length > 15
                                          ? file.title.substring(0, 15) + "..."
                                          : file.title
                                        : file.name
                                        ? file.name.length > 15
                                          ? file.name.substring(0, 15) + "..."
                                          : file.name
                                        : ""}
                                    </a>
                                  </>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                        {/* </section> */}
                      </Form.Group>
                      {this.state.indexOfInputField === idx &&
                        this.showingErroMessage(
                          this.state.key === "issueDescription",
                          indexOfInputField
                        )}
                      {this.props.showLanguageError === false &&
                        (val.issueDescription === "" ||
                          val.issueDescription === undefined ||
                          /^(<p><br><\/p>)+$/g.test(val.issueDescription)) &&
                        this.showInputFieldErrorMessage(
                          "issueDescription",
                          idx
                        )}
                    </Form.Group>

                    {isEdit ? (
                      <div
                        className="button-group"
                        onClick={this.handleDisplayDropdown}
                      >
                        {isFormTypeNotDefault ? (
                          <div className="add-attachment-issue ">
                            <div
                              className="add-attachment-button"
                              style={{ marginLeft: 3 }}
                              onClick={() => onToggleAttachment(idx)}
                            >
                              <Image src={IconPin} alt="Attachment Icon" />
                              Add Attachment
                            </div>
                          </div>
                        ) : (
                          <div className="add-attachment-issue ">
                            <div
                              className="add-attachment-button"
                              style={{ marginLeft: 3 }}
                              onClick={() => onToggleAttachment(idx)}
                            >
                              <Image src={IconPin} alt="Attachment Icon" />
                              Add Attachment
                            </div>
                          </div>
                        )}
                        {/* {idx === issueCOList.length - 1 && !isEdit && (
                          <Button
                          onClick={() => {
                            this.resetFields(idx);
                          }}
                            className="btn-orange-invert no-padding create-issue-submit"
                          >
                            Reset
                          </Button>
                        )} */}{" "}
                        {}
                        {(idx > 0 && (
                          <div
                            className="btn-icon remove-issue"
                            title="Delete Issue"
                            onClick={() => {
                              this.onRemoveFields(idx);
                            }}
                          >
                            Delete Issue
                          </div>
                        )) ||
                          null}
                        <Button
                          className="btn-orange"
                          onClick={this.onValidateForm}
                          style={{
                            marginRight: "3px"
                            // marginLeft: isFormTypeNotDefault ? "auto" : null
                          }}
                        >
                          UPDATE
                        </Button>
                      </div>
                    ) : showModal ? (
                      <div
                        className="button-group-model"
                        onClick={this.handleDisplayDropdown}
                        style={{ height: "86px" }}
                      >
                        {isFormTypeNotDefault ? null : (
                          <div
                            className="add-attachment-issue"
                            style={{
                              position: "relative",
                              left: "0%",
                              top: "39%"
                            }}
                          >
                            <div
                              className="add-attachment-button"
                              onClick={() => onToggleAttachment(idx)}
                            >
                              <Image src={IconPin} alt="Attachment Icon" />
                              Add Attachment
                            </div>
                          </div>
                        )}
                        {/* {idx === issueCOList.length - 1 && !isEdit && (
                        <Button
                        onClick={() => {
                          this.resetFields(idx);
                        }}
                          className="btn-orange-invert no-padding create-issue-submit"
                        >
                          Reset
                        </Button>
                      )} */}{" "}
                        {}
                        {isFormTypeNotDefault ? null : get(
                            user,
                            "groupCategory"
                          ) !== "PMG" && isEdit ? null : showModal ? ( // </div> //   Reset Issue // > //   }} //     this.resetFields(idx); //   onClick={() => { //   title="Reset Issue" //   className="reset-issue" // <div
                          <Button
                            onClick={() => {
                              this.onModelSelect();
                            }}
                            className="back-button btn-orange-invert no-padding issue-back-btn btn"
                            style={{
                              position: "relative",
                              left: "40.5%",
                              bottom: "8%"
                            }}
                          >
                            <span className="issue-back-icon" /> Back
                          </Button>
                        ) : (
                          <Button
                            onClick={() => {
                              this.resetFields(idx);
                            }}
                            className="btn-orange-invert no-padding create-issue-submit reset-button-issue"
                          >
                            Reset
                          </Button>
                        )}
                        {(idx > 0 && (
                          <div
                            className="btn-icon remove-issue"
                            title="Delete Issue"
                            onClick={() => {
                              this.onRemoveFields(idx);
                            }}
                          >
                            Delete Issue
                          </div>
                        )) ||
                          null}
                        <Button
                          className="btn-orange"
                          onClick={this.onValidateForm}
                          style={{
                            position: "relative",
                            left: "61.5%",
                            bottom: "91%"
                          }}
                        >
                          SUBMIT FOR VERIFICATION
                        </Button>
                      </div>
                    ) : (
                      <div
                        className="button-group"
                        onClick={this.handleDisplayDropdown}
                      >
                        {isFormTypeNotDefault ? null : (
                          <div className="add-attachment-issue ">
                            <div
                              className="add-attachment-button"
                              onClick={() => onToggleAttachment(idx)}
                            >
                              <Image src={IconPin} alt="Attachment Icon" />
                              Add Attachment
                            </div>
                          </div>
                        )}
                        {/* {idx === issueCOList.length - 1 && !isEdit && (
                        <Button
                        onClick={() => {
                          this.resetFields(idx);
                        }}
                          className="btn-orange-invert no-padding create-issue-submit"
                        >
                          Reset
                        </Button>
                      )} */}{" "}
                        {}
                        {isFormTypeNotDefault ? null : get(
                            user,
                            "groupCategory"
                          ) !== "PMG" && isEdit ? null : showModal ? ( // </div> //   Reset Issue // > //   }} //     this.resetFields(idx); //   onClick={() => { //   title="Reset Issue" //   className="reset-issue" // <div
                          <Button
                            onClick={() => {
                              this.onModelSelect();
                            }}
                            className="back-button btn-orange-invert no-padding issue-back-btn btn"
                          >
                            <span className="issue-back-icon" /> Back
                          </Button>
                        ) : (
                          <Button
                            onClick={() => {
                              this.resetFields(idx);
                            }}
                            className="btn-orange-invert no-padding create-issue-submit reset-button-issue"
                          >
                            Reset
                          </Button>
                        )}
                        {(idx > 0 && (
                          <div
                            className="btn-icon remove-issue"
                            title="Delete Issue"
                            onClick={() => {
                              this.onRemoveFields(idx);
                            }}
                          >
                            Delete Issue
                          </div>
                        )) ||
                          null}
                        <Button
                          className="btn-orange"
                          onClick={this.onValidateForm}
                          style={{
                            marginRight: showModal ? "0px" : null
                          }}
                        >
                          SUBMIT FOR VERIFICATION
                        </Button>
                      </div>
                    )}
                  </Form.Row>
                </div>
              );
            })) ||
            null}
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    pageDetail: state.createProjectReducer.pageDetail,
    issuesCategoryListStatus:
      state.createProjectReducer.issuesCategoryListStatus,
    issuesSubCategoryListStatus:
      state.createProjectReducer.issuesSubCategoryListStatus,
    issuesCategoryList: state.commonReducer.issuesCategoryList,
    isImageUpLoading: state.commonReducer.isImageUpLoading,
    bucketList: state.commonReducer.bucketList,
    bucketListStatus: state.commonReducer.BucketListStatus,
    milesTableList: state.commonReducer.milesTableList,
    milestoneTableStatus: state.commonReducer.milestoneTableStatus,
    milestoneDataList: state.commonReducer.milestoneDataList,
    milestoneDataListStatus: state.commonReducer.milestoneDataListStatus,
    issueData: state.issueDetailsReducer.issueData
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      uploadFileDispatch: uploadFileAction,
      removeFileDispatch: removeFileAction,
      getIssuesCategoryListDispatch: getIssuesCategoryListAction,
      getProjectPageInfoDispatch: getProjectPageInfoAction,
      getIssuesSubCategoryListDispatch: getIssuesSubCategoryListAction,
      getForumListDispatch: getForumListAction,
      getGroupCategoryIdDispatch: getGroupCategoryIdAction,
      getGroupByCategoryAndParentId: getGroupByCategoryAndParentId,
      getBucketListDispatch: getBucketListAction,
      getMilestoneTableDataDispatch: getMilestoneTableDataAction,
      getMilestonesDataDispatch: getMilestonesDataAction
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddIssueForm);
